import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../../components/common/header";
import Footer from "../../components/common/footer";
import productImage from "../../assets/images/Frame 20.png";
import referralIMage from "../../assets/images/Image-referral.png";
import copyIcon from "../../assets/images/copy_icon.png";
import linkIcon from "../../assets/images/link_icon.png";
import pendingIcon from "../../assets/images/pending_icon.png";
import copleteIcon from "../../assets/images/complete_icon.png";
import emptyBox from "../../assets/images/empty_box.png";
import {
  faCopy,
  faLink,
  faEdit,
  faHome,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { useUser } from "../../contexts/userContext";
import "./media_dashboard.css";
import "./media_account.css";
import "./media_referral.css";
import "./media_order_detail.css";
import "./userProfileUpdatePage.css";
import "../../components/common/style.css";
import "../../components/common/responsive.css";
import "../orderSummary/orderSummaryPage.css";
import "../sell-now/media_sell_now_listing.css";
import "../home/homePage.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ProgressBar from "../stepPage/stepPage";
import { set } from "date-fns";
import { Modal } from "bootstrap";
import DatePicker from "react-datepicker";
import { useCart } from "../../contexts/cartContext";
import { RESEND_OTP_TIMEOUT } from "../../components/common/constant";

interface Order {
  order_id: number;
  order_details: {
    order_id: number;
    user_id: number;
    order_no: string;
    coupon_code: string | null;
    coupon_type: string | null;
    coupon_value: string | null;
    total_value: string;
    created_by: number;
    updated_by: number | null;
    created_at: string;
    updated_at: string | null;
    status_id: number;
    evaluated_price: string | null;
    final_pay_amt: string | number | null;
    assigned_to: string | null;
    pickup_datetime: string | null;
    ip_address: string | null;
    status_title: string;
    applied_pickup_fee: any;
    order_voucher: string | null;
    total_base_value:string;
  };
  carts: {
    cart_id: number;
    items: {
      product_id: number;
      title: string;
      img_name: string;
      evaluated_value: number;
      quantity: number;
      base_value: number;
    }[];
  }[];

  order_quantity: number;
}

interface UserData {
  id: number;
  name: string;
}

interface UserInfoAccountProps {
  userData: UserData;
  setUserData: (data: UserData) => void;
  handleEditUser: (id: number, field: string) => void;
}

interface AddressData {
  add_id: number;
  order_id: number;
  customer_name: string;
  mobile_no: string;
  address_1: string;
  address_2: string;
  landmark: string;
  state_id: number;
  city: string;
  pincode: string;
  is_default: number;
  address_type: number;
  name: string;
}

interface Address {
  address_id: number;
  user_id: number;
  address_1: string;
  address_2: string;
  landmark: string;
  state: string;
  city: string;
  pincode: string;
  is_default: boolean;
  state_id: string;
}

interface CancelReason {
  title: string;
}

interface SearchBarProps {
  onSearch: (query: string) => void; // Function to handle the search
}

interface FlashMessageProps {
  message: string;
  onClose: () => void;
}


const ProfilePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    user_id,
    user_name,
    auth_token,
    setUsername,
    checkSessionTokenExpirationStatus,
    handleRemoveLocalStorage,
    globalAddressErrors,
    handleAddressErrorChange,
    fetchCsrfToken
  } = useUser();
  const [seconds, setSeconds] = useState(120);
  const [userData, setUserData] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const [errorCancel, setErrorCancel] = useState<null | string>(null);
  const [mobileNo, setMobileNo] = useState("");
  const [orders, setOrders] = useState<Order[]>([]); // Typed as Order array
  const [showFlashMessage, setShowFlashMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeSection, setActiveSection] = useState<string>("Pickups");
  const [ordersFound, setOrdersFound] = useState(true);
  const [viewingOrderDetails, setViewingOrderDetails] =
    useState<boolean>(false);
  const [selectedOrder, setSelectedOrder] = useState<Order | null>(null);
  const [selectedOrderAddress, setSelectedOrderAddress] =
    useState<AddressData | null>(null);
  const [showFirstPopup, setShowFirstPopup] = useState(false);
  const [showSecondPopup, setShowSecondPopup] = useState(false);
  const [cancelReasons, setCancelReasons] = useState<CancelReason[]>([]);
  const [selectedReason, setSelectedReason] = useState<string | null>(null);
  const [orderId, setOrderId] = useState<number | null>(null);
  const [selectedAddress, setSelectedAddress] = useState<any | null>(null);
  const [addresses, setAddresses] = useState<Address[]>([]);
  const [selectedAddressId, setSelectedAddressId] = useState<number | null>(
    null
  );
  const [showModalInfo, setShowModalInfo] = useState(false);
  const [popupMsg, setPopupMsg] = useState("");
  const [showPopupAddress, setShowPopupAddress] = useState<number | null>(null);
  const [showPopup, setShowPopup] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showDeleteInfoModal, setShowDeleteInfoModal] = useState(false);
  const [title, setTitle] = useState("");
  const [orderNo, setOrderNo] = useState("");
  const [createdAt, setCreatedAt] = useState("");
  const [customReason, setCustomReason] = useState<string>("");
  const [isOtherSelected, setIsOtherSelected] = useState<boolean>(false);
  const [showNoOrdersPopup, setShowNoOrdersPopup] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [originalData, setOriginalData] = useState({ name: "", email: "" });
  const [isLoading, setIsLoading] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true); // Disable resend button initially
  const [pinServiceableStatus, setPinServiceableStatus] = useState<
    boolean | null
  >(null);
  const [pinServiceableMessage, setPinServiceableMessage] = useState("");
  const { sess_code, setSessionCode } = useUser();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const version = process.env.REACT_APP_VERSION;
  const auth_tokenn = auth_token;
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const nameInputReff = useRef<Array<HTMLInputElement | null>>([]);
  const [isVerifyDisabled, setIsVerifyDisabled] = useState(true);
  const [addressAdd, setNewAddress] = useState({
    address_1: "",
    address_2: "",
    landmark: "",
    city: "",
    state: "",
    pincode: "",
  });
  const [addressNumber, setAddressNumber] = useState<number | null>(
    null
  );
  const [pickupSlotDate, setPickupSlotDate] = useState<any>(null);
  const [cartItems, setCartItems] = useState<any[]>([]);
  const [selectPickupSlotDate, setSelectPickupSlotDate] = useState<any>(null);
  const [pickupDateSelectError, setPickupDateSelectError] = useState<any>(null);
  const [pickupDateObj, setPickupDateObj] = useState([]);
  const [reschedulePopupButtonTriggered, setReschedulePopupButtonTriggered] =
    useState({
      reschedulePickupDateStatus: false,
      rescheduleOrderReasonStatus: false,
    });
  const [reschedulePickupOrderReason, setReschedulePickupOrderReason] =
    useState<any>(null);
  const [
    reschedulePickupOrderReasonErrorMessage,
    setReschedulePickupOrderReasonErrorMessage,
  ] = useState<any>(null);
  const [selectedRescheduleOrder, setSelectedRescheduleOrder] =
    useState<any>(null);
  const [rescheduleOrderPopupClose, setSelectedRescheduleOrderPopupClose] =
    useState(false);
  const {
    setcityName,
    globalSearchTerm,
    setGlobalSearchTerm,
    setUserId,
    setUtmSessionId,
  } = useUser();
  const { cartQuantity, setCartQuantity ,handleQuantity, getBannerOrImageAltTag} = useCart();
  const [currentView, setCurrentView] = useState<
    "login" | "register" | "verifyOtp"
  >("login");
  const [isVisibleOrderNo, setIsVisibleOrderNo] = useState<string | null>(null);
  const [cancelOrderPopupSubmitStatus, setCancelOrderPopupSubmitStatus] = useState(false)
  const [removeAccountVerifyOtpModal,setRemoveAccountVerifyOtpModal] = useState(false)

  // const user_id = location.state?.user_id || localStorage.getItem('user_id');

  // //console.log("--------------->>use--user", seconds)

  if (!user_id) {
    setTimeout(() => {
    navigate("/");
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, 5000)
  }

  const fetchSeoMetaDetails = async (code:any) => {
    try {
        
        const response = await fetch(`${backendUrl}${version}seo-meta-details/${code}`,
          {  method: 'GET',
            headers:{
              // Accept:'aplication/json',
              "Content-Type": "application/json"
      
            },
            credentials: "include",
          mode:"cors"   
                              
          }
        );
        if (!response.ok) throw new Error('Failed to fetch categories');
        const data = await response.json();
        await changeTitleAndMetaTags(data.result.page_title, {description:data.result.meta_description,keywords:data.result.meta_tag});
    } catch (error) {
        //console.error('Error fetching categories:', error);
    }
  };
  
  const changeTitleAndMetaTags = async (
    title: string,
    metaTags: { description?: string; keywords?: string; [key: string]: string | undefined }
  ) => {
    try {
        // Update the document title
        if (title) {
            document.title = title;
        } else {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
        }
  
        // Update or create meta tags
        Object.keys(metaTags).forEach((metaName) => {
            const metaTag = document.querySelector(`meta[name="${metaName}"]`);
            if (metaTag) {
                // Update existing meta tag
                metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
            } else {
                // Create new meta tag if it doesn't exist
                const newMetaTag = document.createElement('meta');
                newMetaTag.name = metaName;
                newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
                document.head.appendChild(newMetaTag);
            }
        });
  
        // Cleanup function to reset the title and meta tags when unmounting
        return () => {
            document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
            Object.keys(metaTags).forEach((metaName) => {
                const metaTag = document.querySelector(`meta[name="${metaName}"]`);
                if (metaTag) {
                    metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
                }
            });
        };
    } catch (error) {
        //console.error("Error updating title and meta tags:", error);
    }
  };

  const fetchOrders = async () => {
    setLoading(true);
    setError(null); // Clear previous error
    try {
      const response = await fetch(`${backendUrl}${version}orders/${user_id}`, {  method: 'GET',
        headers:{
          // Accept:'aplication/json',
          "Content-Type": "application/json",
          "auth-token": `${auth_token}`,
  
        },
        credentials: "include",
          mode:"cors"   
                  
      });
      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
          // setError("Access forbidden: You don't have permission to view cart items.");
          localStorage.clear()
          sessionStorage.clear()
          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/");
          }, 3000);
          return;
        }
  
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      // //console.log("-------------data----not", result.data)
      setOrders(result.data);
    } catch (err: any) {
      setError("Failed to fetch orders.");
    } finally {
      setLoading(false);
    }
  };

  const openEditModal = () => {
    setOriginalData({ name: userData.name, email: userData.email });
    setIsModalOpen(true);
  };

  useEffect(() => {
    document
      .querySelectorAll(".modal-backdrop")
      .forEach((backdrop) => backdrop.remove());
    sessionStorage.removeItem("requestData");
    sessionStorage.removeItem("categoryType");
    sessionStorage.removeItem("categoryId");
    fetchSeoMetaDetails('orders_summary_page')
    setCurrentView("login");
    if (orders.length === 0) {
      setOrdersFound(false);
    } else {
      setOrdersFound(true);
    }
  }, [orders]);
  const searchOrders = async () => {
    const queryString = new URLSearchParams({
      title,
      orderNo,
      createdAt,
    }).toString();

    try {
      const response = await fetch(
        `${backendUrl}${version}orders/${user_id}/search?${queryString}`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,
    
          },
          credentials: "include",
          mode:"cors"              
        }
      );

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
          // setError("Access forbidden: You don't have permission to view cart items.");
          localStorage.clear()
          sessionStorage.clear()
          setShowFlashMessage(true);
            setTimeout(() => {
              navigate("/");
            }, 3000);
          return;
        }
  
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      //console.log("API Response:", data);

      if (data.data && Array.isArray(data.data)) {
        setOrders(data.data);
        setOrdersFound(true);
      } else {
        setOrders([]);
        setOrdersFound(false);
      }
    } catch (err) {
      //console.error("Error fetching orders:", err);
      setError("Error fetching orders.");

    }
  };
  const fetchUserData = async () => {
    if (user_id) {
      try {
        const response = await fetch(
          `${backendUrl}${version}fetch-user/${user_id}`,
          {  method: 'GET',
            headers:{
              // Accept:'aplication/json',
              "Content-Type": "application/json",
              "auth-token": `${auth_token}`,
      
            },
            credentials: "include",
            mode:"cors"                    
          }
        );
        if (!response.ok) {
          //console.error("Error fetching cart items:", response.status, response.statusText);
          
          // Handle 403 Forbidden explicitly
          if (response.status === 403) {
            // setError("Access forbidden: You don't have permission to view cart items.");
            localStorage.clear()
            sessionStorage.clear()
            setShowFlashMessage(true);
            setTimeout(() => {
              navigate("/");
            }, 3000);
            return;
          }
    
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        if (data.result) {
          setUserData(data.result);
        } else {
          setError("Failed to fetch user data");
        }
      } catch (err: any) {
        setError("Failed to fetch user data");
      }
    } else {
      setError("User ID not found");
    }
  };
  useEffect(() => {
    fetchUserData();
    fetchOrders();
    fetchAddresses();
  }, [user_id, backendUrl, version]);

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const dateValue = e.target.value; // Format is yyyy-mm-dd (default for date input)
    const [year, month, day] = dateValue.split("-");
    setCreatedAt(`${day}/${month}/${year}`);
  };

  const fetchAddresses = async () => {
    try {
      const response = await fetch(
        `${backendUrl}${version}All-Address/${user_id}`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,
    
          },
          credentials: "include",
          mode:"cors"               
        }
      );

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
          // setError("Access forbidden: You don't have permission to view cart items.");
          localStorage.clear()
          sessionStorage.clear()
          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/");
          }, 3000);
          return;
        }
  
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      //console.log("data.data.length----",data.data.length)
      setAddressNumber(data.data.length)
      if (response.ok) {
        if (data.data) {
          setAddresses(data.data as Address[]); // Cast to Address array
        } else {
          setError("No address found for this user.");
        }
      }
    } catch (err: any) {
      // setError("Error fetching address");
    }
  };

  const handleUpdateAddressSubmit = async (
    e: React.FormEvent,
    address_id: any
  ) => {
    e.preventDefault();

    try {
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(
        `${backendUrl}api/v2/update-user-Address/${address_id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,
            'X-CSRF-Token': csrfToken,
          },
          credentials: "include",
          body: JSON.stringify({
            addressAdd,
          }),
          
        }
      );

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
          // setError("Access forbidden: You don't have permission to view cart items.");
          localStorage.clear()
          sessionStorage.clear()
          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/");
          }, 3000);
          return;
        }
  
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      setNewAddress({
        address_1: "",
        address_2: "",
        landmark: "",
        city: "",
        state: "",
        pincode: "",
      });
      fetchAddresses();
      // alert('Address added successfully');
      setShowPopupAddress(null); // Close popup on success
    } catch (error) {
      //console.error("Error adding address:", error);
      setPopupMsg("Failed to add address")
      setShowModalInfo(true);
      // alert("Failed to add address");
    }
  };

  const handleDeleteAddress = async (address_id: any) => {
    try {
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(
        `${backendUrl}api/v2/delete-user-address/${address_id}`,
        {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,
            'X-CSRF-Token': csrfToken,
          },
          credentials: "include",
        }
      );

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
          // setError("Access forbidden: You don't have permission to view cart items.");
          localStorage.clear()
          sessionStorage.clear()
          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/");
          }, 3000);
          return;
        }
  
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      fetchAddresses();
      // alert('Address added successfully');
      setShowPopupAddress(null); // Close popup on success
      window.location.reload();
    } catch (error) {
      //console.error("Error adding address:", error);
      setPopupMsg("Failed to add address")
      setShowModalInfo(true);
    }
  };

  const handlePincodeChange = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { value } = e.target;

    // Allow only digits and limit input to 6 characters
    if (/^\d{0,6}$/.test(value)) {
      setNewAddress((prevState) => ({
        ...prevState,
        pincode: value,
      }));
      setPinServiceableMessage("");
      setPinServiceableStatus(false);

      if (value.length === 6) {
        // Check if the pincode is 6 digits
        try {
          const response = await fetch(`${backendUrl}api/v2/pincode/${value}`,
            {  method: 'GET',
              headers:{
                // Accept:'aplication/json',
                "Content-Type": "application/json",
                "auth-token": `${auth_token}`,
        
              },
              credentials: "include",
              mode:"cors"                      
            }
        );

          if (!response.ok) {
            //console.error("Error fetching cart items:", response.status, response.statusText);
            
            // Handle 403 Forbidden explicitly
            if (response.status === 403) {
              // setError("Access forbidden: You don't have permission to view cart items.");
              localStorage.clear()
              sessionStorage.clear()
              setShowFlashMessage(true);
              setTimeout(() => {
                navigate("/");
              }, 3000);
              return;
            }
      
            throw new Error(`HTTP error! Status: ${response.status}`);
          }

          const data = await response.json();

          if (data.data) {
            const { city, state } = data.data;
            if (Object.keys(data.data).length === 0) {
              setNewAddress((prevState) => ({
                ...prevState,
                city: "",
                state: "",
              }));
              setPinServiceableMessage("Pincode is not serviceable");
              setPinServiceableStatus(true);
            } else {
              setNewAddress((prevState) => ({
                ...prevState,
                city,
                state,
              }));
              setPinServiceableMessage("");
              setPinServiceableStatus(false);
            }
          } else {
            // Handle case where no data is found
            //console.error("No data found for pincode");
            setNewAddress((prevState) => ({
              ...prevState,
              city: "",
              state: "",
            }));
            setPinServiceableMessage("Pincode is not serviceable");
            setPinServiceableStatus(true);
          }
        } catch (error) {
          //console.error("Error fetching pincode data:", error);
          setNewAddress((prevState) => ({
            ...prevState,
            city: "",
            state: "",
          }));
          setPinServiceableMessage("Pincode is not serviceable");
          setPinServiceableStatus(true);
        }
      }
    }
  };

  const fetchOrderAddress = async (orderId: any) => {
    if (user_id) {
      try {
        const response = await fetch(
          `${backendUrl}${version}orderAdd/${orderId}`,
          {  method: 'GET',
            headers:{
              // Accept:'aplication/json',
              "Content-Type": "application/json",
              "auth-token": `${auth_token}`,
      
            },
            credentials: "include",
            mode:"cors"                  
          }
        );

        if (!response.ok) {
          //console.error("Error fetching cart items:", response.status, response.statusText);
          
          // Handle 403 Forbidden explicitly
          if (response.status === 403) {
            // setError("Access forbidden: You don't have permission to view cart items.");
            localStorage.clear()
            sessionStorage.clear()
            setShowFlashMessage(true);
            setTimeout(() => {
              navigate("/");
            }, 3000);
            return;
          }
    
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        if (data.data) {
          setSelectedOrderAddress(data.data);
        } else {
          setError("Failed to fetch user data");
        }
      } catch (err: any) {
        setError("Failed to fetch order data");
      }
    } else {
      setError("User ID not found");
    }
  };

  const handleSectionChange = (section: string) => {
    setActiveSection(section);
    setViewingOrderDetails(false);
    fetchSeoMetaDetails('profile_page')
    // window.location.reload();
  };

  const handleSectionnChange = (section: string) => {
    setActiveSection(section);
    setViewingOrderDetails(false);
    //console.log("---->>>>>>>", orders);
    window.location.reload();
    if (orders.length == 0) {
      window.location.reload();
    }
  };

  const handleBack = () => {
    window.location.reload();
    navigate("/profile");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleOrderDetailsClick = (order: Order) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setSelectedOrder(order);
    fetchOrderAddress(order.order_details.order_id);
    setViewingOrderDetails(true);
  };

  const handleCancelOrderClick = (order: Order) => {
    setSelectedOrder(order);
    setOrderId(order.order_details.order_id);
    // setShowFirstPopup(true);
    fetchCancelReasons();
    setIsVisibleOrderNo(null)
  };

  const handleSaveChanges = async () => {
    const updatedData: any = {};

    // Check for changes and add only updated fields
    if (userData.name !== originalData.name) {
      updatedData.name = userData.name;
    }
    if (userData.email !== originalData.email) {
      updatedData.email = userData.email;
    }

    // If no fields are updated, show an error message and return
    if (Object.keys(updatedData).length === 0) {
      setError("No changes made.");
      return;
    }

    setUsername(updatedData.name);

    try {
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(
        `${backendUrl}api/v2/user/update/${userData.id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,
            'X-CSRF-Token': csrfToken,
          },
          credentials: "include",
          body: JSON.stringify(updatedData),
          
        }
      );

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
          // setError("Access forbidden: You don't have permission to view cart items.");
          localStorage.clear()
          sessionStorage.clear()
          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/");
          }, 3000);
          return;
        }
  
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (response.ok && data.data) {
        setUserData((prev: any) => ({
          ...prev,
          ...updatedData, // Only update fields that were changed
        }));
        setIsModalOpen(false);
        setError("");
      } else {
        setError(data.message || "Failed to update user information.");
      }
    } catch (error) {
      //console.error("Error updating user:", error);
      setError("An error occurred while updating user information.");
    }
  };

  const fetchCancelReasons = async () => {
    try {
      const response = await fetch(`${backendUrl}api/v2/cancel-reason`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,
    
          },
          credentials: "include",
          mode:"cors"             
        }
    );

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
          // setError("Access forbidden: You don't have permission to view cart items.");
          localStorage.clear()
          sessionStorage.clear()
          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/");
          }, 3000);
          return;
        }
  
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      //console.log("---------->>>>>>>>>>");

      if (data.data) {
        setCancelReasons(data.data); // Cast to Address array
      } else {
        setError("Failed to fetch cancle-reasons.");
      }
    } catch (error) {
      //console.error("Error fetching cancellation reasons", error);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    try {
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(
        `${backendUrl}api/v2/add-Address/${user_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,
            'X-CSRF-Token': csrfToken,
          },
          credentials: "include",
          body: JSON.stringify({
            addressAdd,
          }),
          
        }
      );

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
          // setError("Access forbidden: You don't have permission to view cart items.");
          localStorage.clear()
          sessionStorage.clear()
          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/");
          }, 3000);
          return;
        }
  
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      setNewAddress({
        address_1: "",
        address_2: "",
        landmark: "",
        city: "",
        state: "",
        pincode: "",
      });
      fetchAddresses();
      // fetchAddress()
      // alert('Address added successfully');
      setShowPopup(false); // Close popup on success
    } catch (error) {
      //console.error("Error adding address:", error);
      setPopupMsg("Failed to add address")
      setShowModalInfo(true);
    }
  };

  const handleNextClick = () => {
    // If "Others" is selected and input is empty
    if (isOtherSelected && !customReason.trim()) {
      setErrorCancel("Please specify a reason for cancellation.");
      return; // Prevent proceeding
    }

    if(!selectedReason){
      setErrorCancel("Please specify a reason for cancellation.");
      return; // Prevent proceeding
    }
    // If a predefined reason is selected
    
    //console.log("pppppppppppppppppppppppppppppppppppppp",errorCancel,cancelReasons);
    // If no reason is selected
    // setErrorCancel("Please select a reason before proceeding.");
  };

  const handleConfirmCancel = async () => {
    if(customReason){
      await OrderCancellationRequest(customReason);
    }else{
      await OrderCancellationRequest(selectedReason);
    }
    
    //console.log("Order canceled:", selectedOrder);

    setShowSecondPopup(false);

    window.location.reload();
  };

  const handlecloseConfirmCancel = () => {
    //console.log("Order not canceled:", selectedOrder);
    if (selectedReason || (isOtherSelected && customReason.trim())) {
      setErrorCancel(null); // Clear any previous error
      setSelectedReason(null); // Reset reason state
      setCustomReason(""); // Reset custom reason
      //console.log("Proceeding to the next modal...");
      return;
    }
    // setShowSecondPopup(false);

    // window.location.reload();
  };

  const handleNotConfirmCancel = () => {
    //console.log("Order not canceled:", selectedOrder);
    setShowSecondPopup(false);
    window.location.reload();
    if (selectedReason || (isOtherSelected && customReason.trim())) {
      setErrorCancel(null); // Clear any previous error
      setSelectedReason(null); // Reset reason state
      setCustomReason(""); // Reset custom reason
      //console.log("Proceeding to the next modal...");
      return;
    }
   
  };

  const handleclose = () => {
    //console.log("Order not canceled:", selectedOrder);

    setShowSecondPopup(false);

    window.location.reload();
  };

  const handleSendOtp = async () => {
    try {
      //console.log("---------------->>>>>>resend-----22222233333", isDisabled);
      setShowModal(false);
      setIsLoading(true);
      // setIsDisabled(true);
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(
        `${backendUrl}${version}user/remove-otp/${user_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,
            'X-CSRF-Token': csrfToken,
          },
          credentials: "include",
        }
      );

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
          // setError("Access forbidden: You don't have permission to view cart items.");
          localStorage.clear()
          sessionStorage.clear()
          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/");
          }, 3000);
          return;
        }
  
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();

      if (data.data.send == true) {
        setIsLoading(false);
        setCurrentView('verifyOtp')
        setMobileNo(data.data.mobile_no)
        const modalElement = document.getElementById('exampleModalRemoveUser');
        if (modalElement) {
          const modal = new window.bootstrap.Modal(modalElement);
          modal.show(); // Open the modal
        }
        setIsDisabled(true);
      }
    } catch (err: any) {
      setIsLoading(false);
      setError(err.message || "Failed to send otp");
    }
  };

  const handleRemoveAccount = async () => {
    try {
      setShowModal(true);
    } catch (err: any) {
      setShowModal(false);
      setError(err.message || "Failed to send otp");
    }
  };

  useEffect(() => {
    if (isLoading) {
      document.body.classList.add("disable-scroll");
    } else {
      document.body.classList.remove("disable-scroll");
    }

    return () => {
      document.body.classList.remove("disable-scroll");
    };
  }, [isLoading]);

  const handleRemoveAccountCancel = async () => {
    try {
      setShowModal(false);
    } catch (err: any) {
      setShowModal(false);
      setError(err.message || "Failed to send otp");
    }
  };

  // const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //     const { name, value } = e.target;
  //     setNewAddress(prevState => ({
  //         ...prevState,
  //         [name]: value
  //     }));
  // };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    handleAddressErrorChange(e);
    // Update the address regardless of length
    setNewAddress((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    // Validate the length: minimum of 2, maximum of 50 characters
    if (value.length > 0 && value.length < 2) {
      setError("Address must be at least 2 characters long.");
    } else if (value.length > 50) {
      setError("Address cannot exceed 50 characters.");
    } else {
      setError(null); // Clear error if the input is valid
    }
  };

  const handleAddressChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const addressId = Number(e.target.value);
    const selected = addresses.find(
      (address) => address.address_id === addressId
    );
    setSelectedAddressId(addressId);
    setSelectedAddress(selected); // Store selected address object
  };

  const OrderCancellationRequest = async (customReason: any) => {
    try {
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(
        `${backendUrl}${version}cancel-order/${orderId}/${user_id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,
            'X-CSRF-Token': csrfToken,
          },
          credentials: "include",
          body: JSON.stringify({ customReason }), // Convert the object to a JSON string
          
        }
      );

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
          // setError("Access forbidden: You don't have permission to view cart items.");
          localStorage.clear()
          sessionStorage.clear()
          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/");
          }, 3000);
          return;
        }
  
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();

      if (data.data.message) {
        if (selectedReason || (isOtherSelected && customReason.trim())) {
          setErrorCancel(null); // Clear any previous error
          setSelectedReason(null); // Reset reason state
          setCustomReason(""); // Reset custom reason
          //console.log("Proceeding to the next modal...");
          return;
        }
        setPopupMsg(`${data.data.message}`)
        setShowModalInfo(true);
        // alert(`${data.data.message}`);
      } else {
        if (selectedReason || (isOtherSelected && customReason.trim())) {
          setErrorCancel(null); // Clear any previous error
          setSelectedReason(null); // Reset reason state
          setCustomReason(""); // Reset custom reason
          //console.log("Proceeding to the next modal...");
          return;
        }
        return data;
      }
    } catch (err: any) {
      setError("Error cancelling order");
    }
  };

  const handleDownloadInvoice = async (order_no: any) => {
    setLoading(true);
    try {
      // Fetch the download URL from the backend
      //console.log("order_no--------", order_no);
      const response = await fetch(`${backendUrl}api/v2/invoice/${order_no}`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json"
    
          },
          credentials: "include",
          mode:"cors"              
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch download link");
      }
      const data = await response.json();
      // const url = data.data.url;
      const url = data.data.url;

      // Open the URL in a new tab
      //console.log(url);
      const newTab = window.open(url, "_blank");
    } catch (error) {
      //console.error("Error downloading invoice:", error);
      setPopupMsg("Error downloading invoice. Please try again later.")
        setShowModalInfo(true);
      // alert("Error downloading invoice. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const ReferralProgressBar: React.FC<{
    stepsCompleted: number;
    totalSteps: number;
  }> = ({ stepsCompleted, totalSteps }) => {
    const completedPercentage = (stepsCompleted / totalSteps) * 100;

    return (
      <div className="progress-bar-container">
        <div
          className="progress-bar-completed"
          style={{ width: `${completedPercentage}%` }}
        ></div>
        <div
          className="progress-bar-pending"
          style={{ width: `${100 - completedPercentage}%` }}
        ></div>
      </div>
    );
  };

  const isFormValid = () => {
    return (
      addressAdd.address_1.length >= 2 &&
      addressAdd.address_2.length >= 2 &&
      addressAdd.pincode.length === 6 &&
      addressAdd.city.length > 0
    );
  };

  useEffect(() => {
    const savedMobileNumber = sessionStorage.getItem("mobileNumber");
    if (savedMobileNumber) {
      setMobileNo(savedMobileNumber);
    }
  }, []);

  useEffect(() => {
    const isSessionHandled = sessionStorage.getItem("sessionHandled");
  
    // If the session was already handled, avoid running this logic again
    if (isSessionHandled) return;
  
    // console.log("------>>>>>>>>>>>>>>>>>aboutus-------", checkSessionTokenExpirationStatus());
  
    if (checkSessionTokenExpirationStatus()) {
      // Clear session-related operations
      handleQuantity();
      handleRemoveLocalStorage();
  
      // Set the sessionHandled flag to true to prevent re-execution after reload
      sessionStorage.setItem("sessionHandled", "true");
  
      // Redirect to the homepage
      navigate("/");
  
      // Reload the page to clear cache
      window.location.reload();
    }
  }, []);

  const fetchSelectPickupSlotDate = async () => {
    let fromDate = new Date(new Date().setDate(new Date().getDate() + 2))
      .toISOString()
      .split("T")[0];

    try {
      const response: any = await fetch(
        `${backendUrl}api/v1/warehouse/order-assign-slots?from_date=${fromDate}&pincode=201301`,
        {  method: 'GET',
          headers:{
            // Accept:'aplication/json',
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,
    
          },
          credentials: "include",
          mode:"cors"              
        }
      );

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
          // setError("Access forbidden: You don't have permission to view cart items.");
          localStorage.clear()
          sessionStorage.clear()
          setShowFlashMessage(true);
            setTimeout(() => {
              navigate("/");
            }, 3000);
          // navigate("/"); // Redirect to login if unauthorized
          return;
        }
  
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      const alloweddate = data.data.map(
        (date: any) =>
          new Date(new Date(date).setDate(new Date(date).getDate() - 1))
      );
      //console.log("allowed data", alloweddate);
      setPickupDateObj(alloweddate);
      //console.log("response order assign slot --->", data);
    } catch (e) {
      //console.log("response order assign slot error --->", e);
    }
    //console.log("from date:", fromDate);
  };
  // Convert string dates to Date objects

  const [selectedDate, setSelectedDate] = useState(null);

  // Filter to allow only dates in the allowedDates array
  const isPickupDateAllowed = (date: any) => {
    const formattedDate = date.toISOString().split("T")[0];
    // //console.log("formattedDate", formattedDate);
    return pickupDateObj.some(
      (allowedDate) =>
        new Date(allowedDate).toISOString().split("T")[0] === formattedDate
    );
  };

  const rescheduleOrder = async () => {
    if (
      reschedulePopupButtonTriggered.rescheduleOrderReasonStatus &&
      reschedulePopupButtonTriggered.reschedulePickupDateStatus
    ) {
      setSelectedRescheduleOrderPopupClose(true);
      const csrfToken = await fetchCsrfToken();
      let res:any = await fetch(
        `${backendUrl}api/v2/reschedule-order/${orderId}/${user_id}`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,
            'X-CSRF-Token': csrfToken,
          },
          credentials: "include",
          body: JSON.stringify({
            reschedule_date: selectPickupSlotDate,
            reschedule_reason: reschedulePickupOrderReason,
          }),
          
        }
      );
      if (!res.ok) {
        //console.error("Error fetching cart items:", res.status, res.statusText);
        
        // Handle 403 Forbidden explicitly
        if (res.status === 403) {
          // setError("Access forbidden: You don't have permission to view cart items.");
          localStorage.clear()
          sessionStorage.clear()
          setShowFlashMessage(true);
            setTimeout(() => {
              navigate("/");
            }, 3000);
          return;
        }
        if (res.status === 400) {
          
          res = await res.json();
          setSelectPickupSlotDate(null);
          setReschedulePickupOrderReason("");
          setPickupSlotDate(null);
          setReschedulePopupButtonTriggered({
            rescheduleOrderReasonStatus: false,
            reschedulePickupDateStatus: false,
          });
          setPickupDateSelectError(null);
          setReschedulePickupOrderReasonErrorMessage(null);
          setPopupMsg(res.message);
          setShowModalInfo(true);
          return
        }
        // throw new Error(`HTTP error! Status: ${res.status}`);
      }
      res = await res.json();
      setSelectPickupSlotDate(null);
      setReschedulePickupOrderReason("");
      setPickupSlotDate(null);
      setReschedulePopupButtonTriggered({
        rescheduleOrderReasonStatus: false,
        reschedulePickupDateStatus: false,
      });
      setPickupDateSelectError(null);
      setReschedulePickupOrderReasonErrorMessage(null);
      setPopupMsg("Order rescheduled successfully")
      setShowModalInfo(true);
      // alert("Order rescheduled successfully");
    } else {
      setPickupDateSelectError("Please select a reschedule pickup date.");
      setReschedulePickupOrderReasonErrorMessage(
        "Please enter a reschedule pickup reason"
      );
    }
  };

  const handleCloseModalClick = () => {
    setError("");
    setShowModalInfo(false); // Close the modal
  };

  const rescheduleOrderReason = (e: any) => {
    const val = e.target.value.trimStart();
    //console.log("rescheduleOrderReason", val.length);

    if (val.length > 0) {
      setReschedulePickupOrderReason(val);
      setReschedulePopupButtonTriggered((pre) => ({
        ...pre,
        rescheduleOrderReasonStatus: true,
      }));
    } else {
      setReschedulePickupOrderReason("");
      setReschedulePopupButtonTriggered((pre) => ({
        ...pre,
        rescheduleOrderReasonStatus: false,
      }));
    }
  };

  const handleRescheduleOrderClick = (order: Order) => {
    setSelectedRescheduleOrder(order);
    setIsVisibleOrderNo(null)
    setOrderId(order.order_details.order_id);
    setReschedulePopupButtonTriggered({
      rescheduleOrderReasonStatus: false,
      reschedulePickupDateStatus: false,
    });
  };
  const rescheduleOrderPopupCloseClick = () => {
    setReschedulePopupButtonTriggered({
      rescheduleOrderReasonStatus: false,
      reschedulePickupDateStatus: false,
    });
    setPickupDateSelectError(null);
    setReschedulePickupOrderReasonErrorMessage(null);
    setSelectPickupSlotDate(null);
    setReschedulePickupOrderReason("");
    setPickupSlotDate(null);
  };

  const handleCloseModal = () => {
    setIsDisabled(false);
    setSeconds(RESEND_OTP_TIMEOUT);
    const modalElement: any = document.getElementById("exampleModalRemoveUser");
    //console.log("modalElement: ", modalElement);
    const modalInstance = Modal.getInstance(modalElement); // Get the modal instance
    //console.log("modalInstance: ", modalInstance);

    if (modalInstance) {
      modalInstance.hide(); // Hides the modal
      document
        .querySelectorAll(".modal-backdrop")
        .forEach((backdrop) => backdrop.remove());

      // Ensure modal-related classes are removed
      modalElement.classList.remove("show");
      modalElement.setAttribute("aria-hidden", "true");
      modalElement.style.display = "none";
    }
  };

  useEffect(() => {
    if (removeAccountVerifyOtpModal) {
      const modalElement = document.getElementById("exampleModalRemoveUser");
      if (modalElement) {
        const modalInstance = window.bootstrap.Modal.getInstance(modalElement);
        if (modalInstance) {
          modalInstance.hide(); // Close the modal
        }
      }
  
      // Remove any remaining modal backdrop elements (optional)
      document.querySelectorAll(".modal-backdrop").forEach((backdrop) => backdrop.remove());
        setShowDeleteInfoModal(true);
                
        // Close delete confirmation modal after 5 seconds
        setTimeout(() => {
          setShowDeleteInfoModal(false);
        }, 5000);
          setTimeout(() => {
            localStorage.removeItem("isLoggedIn");
            localStorage.removeItem("user_id");
            localStorage.removeItem("userName");
            localStorage.removeItem("auth_token");
            localStorage.removeItem("city_name");
            localStorage.removeItem("cartQuantity");
            sessionStorage.removeItem("session_code");
            localStorage.removeItem("GlobalSearchTerm");
            sessionStorage.removeItem("requestData");
            sessionStorage.removeItem("categoryType");
            sessionStorage.removeItem("categoryId");
            setUserId(null);
            setUsername(null);
            setcityName(null);
            setUtmSessionId(null);
            setCartQuantity(0);
            setSessionCode("");
            navigate("/");
            window.scrollTo({ top: 0, behavior: "smooth" });
            window.location.reload()
          }, 5000)
    }
  }, [removeAccountVerifyOtpModal]); // Runs when the state changes

  const handleOtpSubmit = async (otpArray: string[]) => {
    // const otpValue = otp.join('');
    const otpValue = otpArray.join(""); // Combine OTP digits into a single string
    //console.log("Submitted OTP:", otpValue);

    if (otpValue.length !== 6) {
      setError("Please Enter Valid Otp.");
      return;
    }

    try {
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(`${backendUrl}api/v1/verify-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "auth-token": `${auth_token}`,
          'X-CSRF-Token': csrfToken,
        },
        credentials: "include",
        body: JSON.stringify({ userId: user_id, otp: otpValue }),
        
      });

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
          // setError("Access forbidden: You don't have permission to view cart items.");
          localStorage.clear()
          sessionStorage.clear()
          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/");
          }, 3000);
          return;
        }
  
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      if (data.data.success == true) {
        localStorage.setItem('isLoggedIn', 'true');
        sessionStorage.removeItem('mobileNumber');
        const csrfToken = await fetchCsrfToken();
        const response = await fetch(`${backendUrl}${version}user/delete-user/${user_id}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'auth-token': `${auth_token}`,
            'X-CSRF-Token': csrfToken,
          },
          credentials: "include",
        }
        );

        if (!response.ok) {
          //console.error("Error fetching cart items:", response.status, response.statusText);
          
          // Handle 403 Forbidden explicitly
          if (response.status === 403) {
            // setError("Access forbidden: You don't have permission to view cart items.");
            localStorage.clear()
            sessionStorage.clear()
            setShowFlashMessage(true);
            setTimeout(() => {
              navigate("/");
            }, 3000);
            return;
          }
    
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const res = await response.json();
        if (res.data.mobile_no == null) {
          setRemoveAccountVerifyOtpModal(true)
          // const modalElement = document.getElementById("exampleModalRemoveUser");
          // if (modalElement) {
          //   const modalInstance = new window.bootstrap.Modal(modalElement);
          //   modalInstance.hide();
          // }
          
          // // Ensure modal backdrop is removed
          // document.querySelectorAll(".modal-backdrop").forEach((backdrop) => backdrop.remove());
          
          // // Show delete confirmation modal
          // setShowDeleteInfoModal(true);
          
          // // Close delete confirmation modal after 5 seconds
          // setTimeout(() => {
          //   setShowDeleteInfoModal(false);
          // }, 5000);
          //   setTimeout(() => {
          //     localStorage.removeItem("isLoggedIn");
          //     localStorage.removeItem("user_id");
          //     localStorage.removeItem("userName");
          //     localStorage.removeItem("auth_token");
          //     localStorage.removeItem("city_name");
          //     localStorage.removeItem("cartQuantity");
          //     sessionStorage.removeItem("session_code");
          //     localStorage.removeItem("GlobalSearchTerm");
          //     sessionStorage.removeItem("requestData");
          //     sessionStorage.removeItem("categoryType");
          //     sessionStorage.removeItem("categoryId");
          //     setUserId(null);
          //     setUsername(null);
          //     setcityName(null);
          //     setUtmSessionId(null);
          //     setCartQuantity(0);
          //     setSessionCode("");
          //     navigate("/");
          //     window.scrollTo({ top: 0, behavior: "smooth" });
          //   }, 5000)
        }
      
        // navigate(returnUrl || '/', { state: { user_id: setUserId, returnUrl, product, cart_id: cartId, session_code: session_code } });
      } 
      else {
        setOtp(new Array(6).fill(""));
        setError("Invalid OTP");
        // nameInputReff.current?.focus();
      }
    } catch (err: any) {
      setOtp(new Array(6).fill(""));
      setError("An unexpected error occurred");
    }
  };

  // Handle resend OTP
  const handleResendOtp = async () => {
    try {
      setIsDisabled(true);
      //console.log("---------------->>>>>>resend-----", isDisabled);
      setSeconds(RESEND_OTP_TIMEOUT);
      let userInfo = {};
      if (userData) {
        userInfo = {
          id: user_id,
          mobile_no: mobileNo,
          email: userData.email,
        };
      }
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(`${backendUrl}api/v2/resend-otp`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "auth-token": `${auth_token}`,
          'X-CSRF-Token': csrfToken,
        },
        credentials: "include",
        body: JSON.stringify({ userInfo }),
        
      });

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
          // setError("Access forbidden: You don't have permission to view cart items.");
          localStorage.clear()
          sessionStorage.clear()
          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/");
          }, 3000);
          return;
        }
  
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      //console.log("OTP resent successfully");
      // Reset timer
      // Disable resend button
    } catch (error) {
      //console.error("Error resending OTP:", error);
      setError("Failed to resend OTP");
    }
  };

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;

    if (isDisabled && seconds > 0) {
      timer = setInterval(() => {
        setSeconds((prev) => prev - 1);
      }, 1000);
    }

    if (seconds <= 0) {
      //console.log("seconds 0", seconds);
      setIsDisabled(false); // Enable resend button
      if (timer) {
        clearInterval(timer);
      }
      handleResendExpireOtp();
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [seconds, isDisabled]);

  const FlashMessage: React.FC<FlashMessageProps> = ({ message, onClose }) => {
    useEffect(() => {
      const timer = setTimeout(() => {
        onClose(); // Hide the flash message after 5 seconds
      }, 3000);
  
      return () => clearTimeout(timer); // Cleanup on unmount
    }, [onClose]);
  
    return (
      <div
        style={{
          position: "fixed",
          top: "0",
          left: "0",
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.3)", // Semi-transparent background
          backdropFilter: "blur(10px)", // Blur effect
          WebkitBackdropFilter: "blur(10px)", 
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 999, // Ensure it appears above other content

        }}
      >
        <div
          style={{
            backgroundColor: "#db5f5f",
            color: "white",
            padding: "10px 20px",
            borderRadius: "5px",
            zIndex: 1000, // Ensure it's on top of blur
            boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
          }}
        >
          Session Expired. Please login to continue.
        </div>
      </div>
    );
  };


  const handleResendExpireOtp = async () => {
    try {
      // setIsDisabled(true);
      // setSeconds(RESEND_OTP_TIMEOUT);
      //console.log("---------------->>>>>>resend-----222222222", isDisabled);
      let userInfo = {};
      if (userData) {
        userInfo = {
          id: user_id,
          mobile_no: mobileNo,
          email: userData.email,
        };
      }
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(`${backendUrl}api/v2/resend-otp-expire`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "auth-token": `${auth_token}`,
          'X-CSRF-Token': csrfToken,
        },
        credentials: "include",
        body: JSON.stringify({ userInfo }),
        
      });

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);
        
        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
          // setError("Access forbidden: You don't have permission to view cart items.");
          localStorage.clear()
          sessionStorage.clear()
          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/");
          }, 3000);
          return;
        }
  
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      //console.log("OTP resent successfully");
      // Reset timer
      // Disable resend button
    } catch (error) {
      //console.error("Error resending OTP:", error);
      setError("Failed to resend OTP");
    }
  };

  const handleChangeOtp = (element: HTMLInputElement, index: number) => {
    const value = element.value.replace(/\D/g, ""); // Allow only digits

    if (value.length === 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Enable "Verify OTP" button only when all 6 digits are filled
      const otpValue = newOtp.join("");

      setIsVerifyDisabled(otpValue.length !== 6);

      // Focus the next input if the current one is filled and it's not the last input
      if (index < otp.length - 1) {
        nameInputReff.current[index + 1]?.focus();
      }

      //console.log("---------otp-value----", otpValue.length);
      if (otpValue.length !== 6) {
        setError("Please enter a 6-digit OTP");
        return;
      }
    } else if (value === "") {
      // Handle backspace case by clearing the input
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
      setIsVerifyDisabled(true); // Disable Verify button on backspace
    }
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    if (e.key === "Backspace") {
      if (!otp[index] && index > 0) {
        nameInputReff.current[index - 1]?.focus();
      }
      const newOtp = [...otp];
      newOtp[index] = ""; // Clear current input
      setOtp(newOtp);
      setIsVerifyDisabled(true); // Disable Verify button on backspace
    }
  };

  const convert_resend_button_timer = () => {
    const minutes = Math.floor(seconds / 60);
    const secondsRemaining = seconds % 60;
    return `${minutes.toString().padStart(2, "0")} m : ${secondsRemaining
      .toString()
      .padStart(2, "0")} s`;
  };

  const modalStyles: { overlay: React.CSSProperties; modal: React.CSSProperties; button: React.CSSProperties  } = {
    overlay: {
        position: 'fixed', // Valid string for 'position'
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    modal: {
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '8px',
        textAlign: 'center',
    },
    button: {
        padding: '5px',
        margin: '8px',
    }
};

const handleOkayDelete = () => {
  localStorage.removeItem("isLoggedIn");
  localStorage.removeItem("user_id");
  localStorage.removeItem("userName");
  localStorage.removeItem("auth_token");
  localStorage.removeItem("city_name");
  localStorage.removeItem("cartQuantity");
  sessionStorage.removeItem("session_code");
  localStorage.removeItem("GlobalSearchTerm");
  sessionStorage.removeItem("requestData");
  sessionStorage.removeItem("categoryType");
  sessionStorage.removeItem("categoryId");
  setUserId(null);
  setUsername(null);
  setcityName(null);
  setUtmSessionId(null);
  setCartQuantity(0);
  setSessionCode("");
  navigate("/");
  window.scrollTo({ top: 0, behavior: "smooth" });
  window.location.reload()
};

  return (
    <div>
      <Header />
      {showFlashMessage && <FlashMessage message={error ?? ""} onClose={() => setShowFlashMessage(false)} />}
      <section className="dashboard">
        <div className="container">
          {/* <div className="section_breadcrumb">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  <a href="/profile">Profile</a>
                </li>
              </ul>
            </div>
          </div>
        </div> */}
          {/* </div> */}
          <h2 className="text-center- my-4">Hi {user_name}</h2>
          <header className="profile-header">
            <div className="dashboard-nav">
              <div className="section-tabs">
                <button
                  className={`tab ${
                    activeSection === "Pickups" ? "active" : ""
                  }`}
                  onClick={() => handleSectionnChange("Pickups")}
                >
                  {/* <i className="fa-solid fa-user"></i>  */}
                  Pickups
                </button>
                <button
                  className={`tab ${
                    activeSection === "Account" ? "active" : ""
                  }`}
                  onClick={() => handleSectionChange("Account")}
                >
                  {/* <i className="fa-solid fa-user"></i>   */}
                  Account
                </button>
                {/* <button
                    className={`tab ${
                      activeSection === "Referrals" ? "active" : ""
                    }`}
                    onClick={() => handleSectionChange("Referrals")}
                  >
                    Referrals
                  </button> */}
              </div>
            </div>
          </header>
          {isLoading && (
            <div className="loading-overlay">
              <div className="loader"></div>
            </div>
          )}
          {!viewingOrderDetails ? (
            // Your existing sections
            activeSection === "Pickups" && (
              <div className="row pick_UP">
                {loading ? (
                  <p>Loading orders...</p>
                ) : error ? (
                  <p>{error}</p>
                ) : orders.length === 0 ? (
                  <section className="no_prod">
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="no_prod_wrap">
                            <img src={emptyBox} alt="User Profile" />
                            <p className="no_prod_txt">No record found!</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                ) : (
                  // setOrdersFound(false);
                  <div className="col-lg-8">
                    {orders.length > 0 ? (
                      orders.map((order) => (
                        // <div key={order.order_id} className="order-card">
                        <div className="order-card">
                          <div className="order-info">
                            <div className="order-row top_sec">
                              <p>
                                <strong>Order No:</strong>{" "}
                                {order.order_details.order_no}
                              </p>
                              <p>
                                <strong>Order Date:</strong>{" "}
                                {(() => {
                                  const createdAt =
                                    order?.order_details?.created_at; // Get the created_at value safely
                                  if (!createdAt) return "Date not available"; // Fallback message if created_at is null or undefined

                                  const dateParts = createdAt
                                    .split("T")[0]
                                    .split("-"); // Split into date parts
                                  return `${dateParts[2].padStart(
                                    2,
                                    "0"
                                  )}/${dateParts[1].padStart(2, "0")}/${
                                    dateParts[0]
                                  }`; // Format as dd/mm/yyyy
                                })()}
                              </p>
                              <p>
                                <strong>Order Status:</strong>
                                {order.order_details.status_title ?? "N/A"}
                              </p>
                              {/* <p>
                                <strong>Picked-up On:</strong>
                                {(() => {
                                  const createdAt =
                                    order?.order_details?.pickup_datetime; // Get the created_at value safely
                                  if (!createdAt) return "Date not available"; // Fallback message if created_at is null or undefined

                                  const dateParts = createdAt
                                    .split("T")[0]
                                    .split("-"); // Split into date parts
                                  return `${dateParts[2].padStart(
                                    2,
                                    "0"
                                  )}/${dateParts[1].padStart(2, "0")}/${
                                    dateParts[0]
                                  }`; // Format as dd/mm/yyyy
                                })()}
                              </p> */}
                              {/* <p className="order-info">Order-Value:</p> */}
                              {/* <p>₹ {parseInt(order.order_details.total_value, 10)}</p> */}
                              <div className="order-buttons">
                                <button
                                  className="view_btn btn btn-success"
                                  onClick={() => handleOrderDetailsClick(order)}
                                >
                                  View Details
                                </button>


                                {!["Cancelled", "Pickup In Process", "Assigned", "Evaluation In Process", 'Paid' , 'Invoiced', 'Ready For Payment', 'Order Pickedup'].includes(order.order_details.status_title) && (
  <i
    className="fa-solid fa-ellipsis-vertical"
    id="toggleButton"
    style={{ cursor: "pointer" }}
    onClick={() =>
      isVisibleOrderNo == null
        ? setIsVisibleOrderNo(order.order_details.order_no)
        : isVisibleOrderNo === order.order_details.order_no
        ? setIsVisibleOrderNo(null)
        : setIsVisibleOrderNo(order.order_details.order_no)
    }
  ></i>
)}
                                {isVisibleOrderNo ===
                                  order.order_details.order_no && (
                                  <div
                                    id="btn_act"
                                    style={{ height: "px", width: "px" }}
                                  >
                                    {[
                                      "Created",
                                      "Processing",
                                      "Confirmation from Customer",
                                    ].includes(
                                      order.order_details.status_title
                                    ) && (
                                      <button
                                        className="cancel_btn btn btn-outline-success"
                                        data-bs-toggle="modal"
                                        data-bs-target="#exampleModalToggle"
                                        style={{
                                          color: "white",
                                          borderColor: "red",
                                          background: "#ff0000cf",
                                        }}
                                        onClick={() =>
                                          handleCancelOrderClick(order)
                                        }
                                      >
                                        Cancel Order
                                      </button>
                                    )}

                                    {[
                                      "Confirmed",
                                      "Confirmation from Customer",
                                    ].includes(
                                      order.order_details.status_title
                                    ) && (
                                      <button
                                        className="cancel_btn btn btn-success res-button"
                                        data-bs-toggle="modal"
                                        data-bs-target="#rescheduleOrderModal"
                                        style={{ color: "white" }}
                                        onClick={() =>
                                          handleRescheduleOrderClick(order)
                                        }
                                      >
                                        Reschedule Order
                                      </button>
                                    )}
                                  </div>
                                )}

                                <div
                                  className="modal fade reason_popop"
                                  id="exampleModalToggle"
                                  aria-hidden="true"
                                  aria-labelledby="exampleModalToggleLabel"
                                  tabIndex={-1}
                                >
                                  <div className="modal-dialog modal-dialog-centered modal-lg">
                                    <div className="modal-content">
                                      <div className="modal-header">
                                        <h1
                                          className="modal-title fs-5"
                                          id="exampleModalToggleLabel"
                                        >
                                          Select a reason for cancellation
                                        </h1>
                                        <button
                                          type="button"
                                          className="btn-close"
                                          data-bs-dismiss="modal"
                                          aria-label="Close"
                                          onClick={() => {
                                                setShowFirstPopup(false)
                                                setErrorCancel(null);
                                            window.location.reload();
                                          }}
                                        ></button>
                                      </div>
                                      <div className="modal-body">
                                        <div className="popup-cancel-order-">
                                          {/* <h2></h2> */}
                                          <ul>
                                            {cancelReasons.map(
                                              (reason, index) => (
                                                <li key={index}>
                                                  <div className="inp_wrap">
                                                  <input
                                                    type="radio"
                                                    name="cancelReason"
                                                    value={reason.title}
                                                    className="reason-for-cancel"
                                                    onChange={() => {
                                                      setSelectedReason(
                                                        reason.title
                                                      );
                                                      // setCancelError(null);

                                                      if (
                                                        reason.title ===
                                                        "Others"
                                                      ) {
                                                        setCustomReason(""); // Clear custom reason for "Others"
                                                        // setCancelError(null)
                                                        setCancelOrderPopupSubmitStatus(false)

                                                        setIsOtherSelected(
                                                          true
                                                        );
                                                      } else {
                                                        setCustomReason(
                                                          reason.title
                                                        ); // Set customReason to the selected title
                                                        setErrorCancel(null);
                                                        setCancelOrderPopupSubmitStatus(true)
                                                        setIsOtherSelected(
                                                          false
                                                        );
                                                      }
                                                      
                                                    }}
                                                   
                                                  />
                                                  </div>
                                                  <div className="reason_title">{reason.title}</div>
                                                </li>
                                              )
                                            )}
                                          </ul>
                                          <div className="other_input">
                                            {isOtherSelected && (
                                              <input
                                                type="text"
                                                value={customReason}
                                                onChange={(e) => {
                                                  const trimmedValue =
                                                    e.target.value.replace(
                                                      /^\s+/,
                                                      ""
                                                    ); // Remove leading spaces
                                                  setCustomReason(trimmedValue);
                                                  
                                                  if (trimmedValue.length > 0) {
                                                    setCancelOrderPopupSubmitStatus(true)
                                                    setErrorCancel(null);
                                                  } else {
                                                    setCancelOrderPopupSubmitStatus(false)
                                                  }
                                                }}
                                                placeholder="Please specify"
                                                className="input-others-reason"
                                                required
                                              />
                                            )}
                                          </div>
                                          {errorCancel && (
                                            <p
                                              className="error-message"
                                              style={{
                                                color: "red",
                                                marginTop: "10px",
                                                fontSize: "14px",
                                                marginLeft: "30px", // Corrected property name
                                                fontWeight:'400'
                                              }}
                                            >
                                              {errorCancel}
                                            </p>
                                          )}

                                          <div className="button-cancel-submit">
                                            {!cancelOrderPopupSubmitStatus ? (
                                              <button
                                                className="btn btn-success"
                                                onClick={handleNextClick}
                                              >
                                                Submit
                                              </button>
                                            ) : (
                                              <button
                                                className="btn btn-success"
                                                data-bs-toggle="modal"
                                                data-bs-target="#exampleModalToggle2"
                                                onClick={handleNextClick}
                                              >
                                                Submit
                                              </button>
                                            )}
                                            <button
                                              className="btn btn-outline-success"
                                              data-bs-dismiss="modal"
                                              aria-label="Close"
                                              onClick={() => {
                                                setShowFirstPopup(false)
                                                // setIsOtherSelected(false);
                                                // setSelectedReason('');
                                                // setCustomReason("");
                                                // setCancelOrderPopupSubmitStatus(false)
                                                handlecloseConfirmCancel()
                                                window.location.reload();
                                              }
                                              }
                                            >
                                              Close
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="modal fade"
                                  id="exampleModalToggle2"
                                  aria-hidden="true"
                                  aria-labelledby="exampleModalToggleLabel2"
                                  tabIndex={-1}
                                >
                                  <div className="modal-dialog modal-dialog-centered modal-lg">
                                    <div className="modal-content">
                                      <div className="modal-header">
                                        <button
                                          type="button"
                                          className="btn-close"
                                          data-bs-dismiss="modal"
                                          aria-label="Close"
                                          onClick={handleclose}
                                        ></button>
                                      </div>
                                      <div className="modal-body">
                                        <div className="popup-cancel-order-">
                                          <h2>
                                            Are you sure you want to cancel this
                                            order?
                                          </h2>
                                          <button
                                            className="btn btn-success"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                            onClick={handleConfirmCancel}
                                          >
                                            Yes
                                          </button>
                                          <button
                                            className="btn btn-outline-success"
                                            data-bs-dismiss="modal"
                                            aria-label="Close"
                                            onClick={handleNotConfirmCancel}
                                          >
                                            No
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {/* First Popup: Reason selection */}

                                {/* Second Popup: Confirmation */}
                              </div>
                            </div>
                            <div>
                              {order.carts && Array.isArray(order.carts) ? (
                                // Take the first item from the carts array
                                order.carts.slice(0, 1).map((cart: any) => (
                                  // <div className="bottom_sec_wrap d-flex align-items-center">
                                  <div className="bottom_sec_wrap d-flex align-items-center">
                                    <div className="order-image">
                                      <img
                                        src={cart.img_name}
                                        // className='image-prod'
                                        alt={getBannerOrImageAltTag('image',cart)}
                                        onError={(e: any) => {
                                          e.target.onerror = null; // Prevent infinite loop
                                          e.target.src = productImage; // Set fallback image
                                        }}
                                      />
                                    </div>
                                    <div className="inside_info">
                                      <div className="order-row">
                                        <p>
                                          <strong>{cart.title}</strong>
                                        </p>
                                        {order?.order_quantity > 1 && (
                                          <div className='disp_more_prod for_web'>
                                          <p className="show_more">
                                            + {order.order_quantity - 1} more {order.order_quantity - 1 === 1 ? "product" : "products"}
                                            <div className="triangle triangle-4"></div>
                                          </p>
                                          </div>
                                        )}
                                      </div>
                                      <p className="pro_name">
                                        {cart.productParent.title}
                                      </p>

                                      <div className="orders-row">
                                        <p
                                          className="att_cart_prod_info"
                                          dangerouslySetInnerHTML={{
                                            __html: cart?.attributes
                                              ? Object.entries(cart.attributes)
                                                  .map(
                                                    ([key, value]) =>
                                                      `<div class="attr_blok"><i>${key}</i> : ${String(
                                                        value
                                                      )}</div>`
                                                  )
                                                  .join(" ")
                                              : "No attributes available",
                                          }}
                                        />

                                        <p className="bd">
                                          <strong>Brand:</strong> {cart.brand}
                                        </p>
                                        <p className="ct">
                                          <strong>Price:</strong> ₹{" "}
                                          {cart.base_value ?? "N/A"}
                                        </p>
                                      </div>
                                      <div className='disp_more_prod for_mob'>
                                      {order?.order_quantity > 1 && (
                                          <p className="show_more">
                                            + {order.order_quantity - 1} more {order.order_quantity - 1 === 1 ? "product" : "products"}
                                            <div className="triangle triangle-4"></div>
                                          </p>
                                          
                                        )}
                                          </div>
                                    </div>
                                    {/* </div> */}
                                  </div>
                                ))
                              ) : (
                                <section className="no_prod">
                                  <div className="container">
                                    <div className="row">
                                      <div className="col-lg-12">
                                        <div className="no_prod_wrap">
                                          <img
                                            src="images/empty_box.png"
                                            alt="User Profile"
                                          />
                                          <p className="no_prod_txt">
                                            No record found!
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </section>
                              )}
                            </div>
                          </div>
                        </div>

                        // </div>
                      ))
                    ) : (
                      <p className="no-address-message">No Orders available</p>
                    )}
                  </div>
                )}
                <div
                  className="modal fade reschedule_pickup"
                  id="rescheduleOrderModal"
                  tabIndex={-1}
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div
                        className="modal-header"
                        style={{ borderBottom: "0 none" }}
                      >
                        <h1 className="modal-title fs-5" id="exampleModalLabel">
                          {/* Modal title */}
                        </h1>
                        <button
                          type="button"
                          className="btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                          onClick={() => rescheduleOrderPopupCloseClick()}
                        ></button>
                      </div>
                      <div className="modal-body">
                        <div className="">
                          <h5>Pickup Schedule</h5>
                          <DatePicker
                            id="date-input"
                            placeholderText="DD-MM-YYYY"
                            selected={pickupSlotDate}
                            onChange={(date: any) => {
                              let formatDate = new Date(
                                new Date(date).setDate(
                                  new Date(date).getDate() + 1
                                )
                              )
                                .toISOString()
                                .split("T")[0];
                              
                              if (formatDate.split("-")[0] === "1970") {
                               
                                setPickupSlotDate(null);
                                setSelectPickupSlotDate(null);
                                setReschedulePopupButtonTriggered((pre) => ({
                                  ...pre,
                                  reschedulePickupDateStatus: false,
                                }));
                              } else {
                                setPickupSlotDate(date);
                                setSelectPickupSlotDate(formatDate);
                                setReschedulePopupButtonTriggered((pre) => ({
                                  ...pre,
                                  reschedulePickupDateStatus: true,
                                }));
                              }
                              setPickupDateSelectError(null);
                            }} // Set selected date
                            filterDate={isPickupDateAllowed} // Enable only allowed dates
                            dateFormat="dd-MM-yyyy" // Date format
                            onCalendarOpen={fetchSelectPickupSlotDate}
                            onKeyDown={(e: any) => e.preventDefault()} // Prevent typing in the input field
                            isClearable
                          />
                          {!reschedulePopupButtonTriggered.reschedulePickupDateStatus &&
                            pickupDateSelectError && (
                              <span className="error-message-pincode-update">
                                {pickupDateSelectError}
                              </span>
                            )}

                          <div className="mt-3">
                            <label
                              className="form-label"
                              style={{ fontSize: "20px", fontWeight: "500" }}
                            >
                              Reason
                            </label>
                            <textarea
                              className="form-control"
                              id="exampleFormControlTextarea1"
                              value={reschedulePickupOrderReason ?? ""}
                              style={{ minHeight: "100px" }}
                              onChange={(e: any) => rescheduleOrderReason(e)}
                            ></textarea>
                            {!reschedulePopupButtonTriggered.rescheduleOrderReasonStatus &&
                              reschedulePickupOrderReasonErrorMessage && (
                                <span className="error-message-pincode-update">
                                  {reschedulePickupOrderReasonErrorMessage}
                                </span>
                              )}
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        {/* <button type="button" className="btn btn-secondary">
                          Close
                        </button> */}
                        <button
                          type="button"
                          className="btn btn-primary res-button"
                          data-bs-dismiss={
                            reschedulePopupButtonTriggered.rescheduleOrderReasonStatus &&
                            reschedulePopupButtonTriggered.reschedulePickupDateStatus
                              ? "modal"
                              : undefined
                          }
                          onClick={rescheduleOrder}
                        >
                          Reschedule Pickup
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {ordersFound ? (
                  <div className="col-lg-4 mb-4">
                    <div className="search-box">
                      <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="Search by Product"
                        className="form-control mb-2"
                      />
                      <input
                        type="text"
                        value={orderNo}
                        onChange={(e) => setOrderNo(e.target.value)}
                        placeholder="Search by Order No"
                        className="form-control mb-2"
                      />
                      <input
                        type="date"
                        value={createdAt}
                        onChange={(e) => setCreatedAt(e.target.value)}
                        className="form-control mb-2"
                        placeholder="dd/mm/yyyy"
                        onKeyDown={(e) => e.preventDefault()} // Prevent manual input
                      />
                      <button
                        onClick={searchOrders}
                        className={`btn w-100 ${
                          title || orderNo || createdAt
                            ? "btn-success"
                            : "btn-secondary"
                        }`}
                        disabled={!title && !orderNo && !createdAt}
                      >
                        Search
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="search-order-back-button"></div>
                )}
              </div>
            )
          ) : (
            // Add other sections like Account and Referrals here
            // Order details view

            <div className="order-details-section">
              <section className="recycle_cart order_Detail">
                <div className="container">
                  <h2 className="text-center mb-4">Order Details</h2>
                  {/* <ProgressBar currentStep={currentStep} /> */}
                  <div className="border_round">
                    {selectedOrder && (
                      <div>
                        <div className="order-details-header">
                          {/* <p className='order-details-heading-top'><p className='heading-order-top'>Order No.: </p> {selectedOrder.order_details.order_no}</p>
                                                <p className='order-details-heading-top'><p className='heading-order-top'>Order date: </p>{new Date(selectedOrder.order_details.created_at).toLocaleDateString('en-GB', {
                                                    day: '2-digit',
                                                    month: '2-digit',
                                                    year: 'numeric',
                                                })}</p> */}

                          {/* <p className='order-details-heading-top'>
                                                    <p className='heading-order-top'>Picked-up On: </p>
                                                    {selectedOrder.order_details.pickup_datetime
                                                        ? new Date(selectedOrder.order_details.pickup_datetime).toLocaleDateString('en-GB', {
                                                            day: '2-digit',
                                                            month: '2-digit',
                                                            year: 'numeric',
                                                        })
                                                        : 'N/A'}
                                                </p> */}
                          {/* <p className='order-details-heading-top'><p className='heading-order-top'>Status: </p> {selectedOrder.order_details.status_title}</p> */}
                          <div className="prod_cont">
                            <h2>Order Details:</h2>
                            <p className="total-products">
                              {selectedOrder.order_quantity} item(s)
                            </p>
                          </div>
                          {/* <a
                            className="cancel-order"
                            onClick={() =>
                              handleDownloadInvoice(
                                selectedOrder.order_details.order_no
                              )
                            }
                          >
                            {loading ? "Downloading..." : "Invoice"}
                          </a> */}
                        </div>
                        <ProgressBar
                          currentStep={selectedOrder.order_details.status_title}
                        />
                        <div className="padd_lft_rit">
                          <div className="row ">
                            <div className="col-lg-8">
                              <div className="card">
                                <h2>Pickup Address</h2>
                                {selectedOrderAddress ? (
                                  <div className="address_line">
                                    <p className="content-text">
                                      {selectedOrderAddress.address_1}
                                    </p>
                                    <p className="content-text">
                                      {selectedOrderAddress.address_2}
                                    </p>
                                    <p className="content-text">
                                      {selectedOrderAddress.landmark}
                                    </p>
                                    <p className="content-text">
                                      {selectedOrderAddress.name}
                                    </p>
                                    <p className="content-text">
                                      {selectedOrderAddress.city}
                                    </p>
                                    <p className="content-text">
                                      ({selectedOrderAddress.pincode})
                                    </p>
                                  </div>
                                ) : (
                                  <p>No Address Provided</p>
                                )}
                              </div>
                            </div>

                            <div className="col-lg-4">
                              <div className="cart-summary price_details order_id_box">
                                <h5>
                                  Order ID:{" "}
                                  {selectedOrder.order_details.order_no}
                                </h5>
                                <div className="Total_Amount">
                                  <p>Total Quoted Price:</p>
                                  {selectedOrder.order_details
                                    .applied_pickup_fee === 0 ? (
                                    <p>
                                      ₹{" "}
                                      {Number(
                                        selectedOrder.order_details.total_base_value
                                      )}
                                    </p>
                                  ) : (
                                    <p>
                                      ₹{" "}
                                      {Number(
                                        selectedOrder.order_details.total_base_value
                                      ) }
                                    </p>
                                  )}
                                </div>
                                {selectedOrder.order_details.order_voucher !=
                                  null && (
                                  <div className="Total_Amount">
                                    <p>Voucher:</p>
                                    <p
                                      className="order_vouch"
                                      style={{ color: "#2E7D32" }}
                                    >
                                      {
                                        selectedOrder.order_details
                                          .order_voucher
                                      }
                                    </p>
                                  </div>
                                )}

                                {/* <div className="dascount_Amount">
                                    <p>Coupon Discount:</p>
                                    <p>₹ 0</p>
                                  </div> */}
                                <div className="ship_Fee">
                                  <p>Pickup Fee:</p>
                                  {selectedOrder.order_details
                                    .applied_pickup_fee == 0 ||
                                  selectedOrder.order_details
                                    .applied_pickup_fee == null ? (
                                    <p>FREE</p>
                                  ) : (
                                    <p>
                                      ₹
                                      {parseInt(
                                        selectedOrder.order_details
                                          .applied_pickup_fee
                                      )}
                                    </p>
                                  )}
                                </div>
                                <div className="Payable_Amount">
                                  <p>Final Total:</p>
                                  <p>
                                    ₹{" "}
                                    {parseInt(
                                      selectedOrder.order_details.total_value
                                    )}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="row">
                            <div className="col-md-12">
                              <table className="od_product" width="100%">
                                <thead>
                                  <tr>
                                    <th className="th-product">Product</th>
                                    <th className="th-type">Attributes</th>
                                    <th className="th-brand">Brand</th>
                                    <th className="th-price">Price</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {selectedOrder.carts.map((cart: any) => (
                                    // <div key={cart.cart_id}>
                                    <tr>
                                      <td className="first_Image">
                                        <img
                                          src={cart.img_name}
                                          className="img-fluid"
                                          alt={getBannerOrImageAltTag('image',cart)}
                                          onError={(e: any) => {
                                            e.target.onerror = null; // Prevent infinite loop
                                            e.target.src = productImage; // Set fallback image
                                          }}
                                        />
                                        <div className="voucher_shown">
                                          <p className="prod_name">
                                            {cart.title}
                                          </p>
                                          {cart.voucher_code !== null ? (
                                            <p className="voucher_applied">
                                              {cart.voucher_code} is applied on
                                              this order
                                            </p>
                                          ) : (
                                            <p></p>
                                          )}
                                        </div>
                                      </td>
                                      <td>
                                        {" "}
                                        <p
                                          className="att_order_prod_info"
                                          dangerouslySetInnerHTML={{
                                            __html: Object.entries(
                                              cart.attributes
                                            )
                                              .map(
                                                ([key, value]) =>
                                                  `<span className="prop_attr"><strong>${key}</strong>: ${String(
                                                    value
                                                  )}</span>`
                                              )
                                              .join(" "),
                                          }}
                                        />
                                      </td>
                                      <td>{cart.brand}</td>
                                      <td>
                                        ₹ {parseInt(cart.base_value ?? "N/A")}
                                      </td>
                                    </tr>

                                    // </div>
                                  ))}
                                </tbody>
                              </table>
                              <div className="review_items order_s_Detail m_view">
                                <div className="card">
                                  {selectedOrder.carts.map((cart: any) => (
                                    <div className="d-flex- align-items-center">
                                      <div className="pickup_item_img">
                                        <img
                                          src={cart.img_name}
                                          className="product-img"
                                          alt={getBannerOrImageAltTag('image',cart)}
                                          onError={(e: any) => {
                                            e.target.onerror = null; // Prevent infinite loop
                                            e.target.src = productImage; // Set fallback image
                                          }}
                                        />
                                      </div>

                                      <div className="pickup_item_img_info">
                                        <div className="pickup_item_img_detail d-flex- justify-content-between align-items-center">
                                          <div className="pro_Naming">
                                            <p>Product:</p>
                                            <p>{cart.title}</p>
                                          </div>
                                          <div className="pro_type">
                                            <p>Attributes:</p>
                                            <p
                                              className="att_order_prod_info"
                                              dangerouslySetInnerHTML={{
                                                __html: Object.entries(
                                                  cart.attributes
                                                )
                                                  .map(
                                                    ([key, value]) =>
                                                      `<span className="prop_attr"><strong>${key}</strong>: ${String(
                                                        value
                                                      )}</span>`
                                                  )
                                                  .join(" "),
                                              }}
                                            />
                                          </div>
                                          <div className="pro_brand">
                                            {" "}
                                            <p>Brand:</p>
                                            <p>{cart.brand}</p>
                                          </div>
                                          <div className="pro_brand">
                                            <p>Price:</p>
                                            <p>
                                              ₹{" "}
                                              {parseInt(
                                                cart.base_value ?? "N/A"
                                              )}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* <button onClick={() => setViewingOrderDetails(false)}>Back to Orders</button> */}
                      </div>
                    )}
                  </div>
                </div>
              </section>
            </div>
          )}
          {activeSection === "Account" && (
            <div className="row">
              {userData ? (
                <div className="col-lg-12">
                  <div className="profile-card">
                    <div className="user-profile-img">
                      {" "}
                      <span className="user-names-profile">
                        {userData.name
                          ? userData.name.charAt(0).toUpperCase()
                          : ""}
                      </span>
                    </div>

                    <div className="profile-details">
                      <h5 className="user-name">
                        {userData?.name
                          ? userData.name.charAt(0).toUpperCase() +
                            userData.name.slice(1).toLowerCase()
                          : "Guest"}
                      </h5>

                      <p className="user-address">+91-{userData.mobile_no}</p>
                      <p className="user-address">{userData.email}</p>
                    </div>
                    {/* <p className='email-edit' onClick={openEditModal}>
                                            <FontAwesomeIcon className="edit-icon" icon={faEdit} />
                                        </p> */}
                    <div
                      className="profile-remove"
                      onClick={handleRemoveAccount}
                    >
                      Remove
                    </div>
                    {/* onClick={openEditModal} */}
                    {isModalOpen && (
                      <div className="modal-overlay">
                        <div className="modal">
                          <h2>Edit User Info</h2>
                          <div className="user-info-account-modal">
                            <label>Name:</label>
                            <input
                              type="text"
                              value={userData.name}
                              onChange={(e) =>
                                setUserData({
                                  ...userData,
                                  name: e.target.value,
                                })
                              }
                              placeholder="Update Name"
                            />
                          </div>
                          <div className="user-info-account-modal">
                            <label>Email:</label>
                            <input
                              type="text"
                              value={userData.email}
                              onChange={(e) =>
                                setUserData({
                                  ...userData,
                                  email: e.target.value,
                                })
                              }
                              placeholder="Update Email"
                            />
                          </div>
                          <div className="user-info-account-modal">
                            <label>Mobile No:</label>
                            <input
                              type="text"
                              value={userData.mobile_no}
                              readOnly
                            />
                          </div>
                          <div className="button-modal">
                            <button
                              className="user-info-account-button"
                              onClick={handleSaveChanges}
                            >
                              Update
                            </button>
                            <button
                              className="user-info-account-button"
                              onClick={() => setIsModalOpen(false)}
                            >
                              Cancel
                            </button>
                          </div>

                          {error && <p className="error">{error}</p>}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="saved-addressed">
                    <h4 className="saved-add">Saved Addresses</h4>
                    <button
                      className="btn btn-success"
                      onClick={() => setShowPopup(true)}
                    >
                      + Add new address
                    </button>
                    {showPopup && (
                      <div className="update_address popup">
                        <div className="popup-content">
                          <div
                            className="edit_address "
                            id="exampleModal"
                            tabIndex={-1}
                            aria-labelledby="exampleModalLabel"
                            aria-hidden="true"
                          >
                            <div className="modal-dialog modal-dialog-centered modal-lg">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h1
                                    className="modal-title fs-5"
                                    id="exampleModalLabel"
                                  >
                                    Address Details
                                  </h1>
                                  <button
                                    className="close-button"
                                    onClick={() => setShowPopup(false)}
                                  >
                                    <FontAwesomeIcon icon={faTimes} />
                                  </button>
                                </div>
                                {/* <p className="button-heading">
                                  Add New Address
                                </p> */}
                                <div className="modal-body">
                                  <form
                                    className="mt-4"
                                    onSubmit={handleSubmit}
                                  >
                                    <div className="row g-3">
                                      <div className="col-md-6">
                                        <label htmlFor="address_1">
                                          Address 1
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>
                                        <input
                                          type="text"
                                          id="address_1"
                                          name="address_1"
                                          placeholder="Enter Address 1"
                                          value={addressAdd.address_1}
                                          onChange={handleInputChange}
                                          className="form-control"
                                          maxLength={50}
                                          required
                                          onInvalid={(e) => {
                                            const target =
                                              e.target as HTMLInputElement;
                                            if (!target.value) {
                                              target.setCustomValidity(
                                                "Address is required."
                                              );
                                            } else if (
                                              target.value.length < 2
                                            ) {
                                              target.setCustomValidity(
                                                "Address must be at least 2 characters long."
                                              );
                                            }
                                          }}
                                          onInput={(e) => {
                                            const target =
                                              e.target as HTMLInputElement;
                                            target.setCustomValidity(""); // Clear error message
                                          }}
                                        />
                                        {globalAddressErrors.address_1_error_status && (
                                          <span className="error-message-pincode-update">
                                            {globalAddressErrors.address_1}
                                          </span>
                                        )}
                                      </div>

                                      <div className="col-md-6">
                                        <label htmlFor="address_2">
                                          Address 2
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>
                                        <input
                                          type="text"
                                          id="address_2"
                                          name="address_2"
                                          placeholder="Enter Address 2"
                                          value={addressAdd.address_2}
                                          onChange={handleInputChange}
                                          className="form-control"
                                          required
                                          maxLength={50}
                                          onInvalid={(e) => {
                                            const target =
                                              e.target as HTMLInputElement;
                                            if (!target.value) {
                                              target.setCustomValidity(
                                                "Address is required."
                                              );
                                            } else if (
                                              target.value.length < 2
                                            ) {
                                              target.setCustomValidity(
                                                "Address must be at least 2 characters long."
                                              );
                                            }
                                          }}
                                          onInput={(e) => {
                                            const target =
                                              e.target as HTMLInputElement;
                                            target.setCustomValidity(""); // Clear error message
                                          }}
                                        />
                                        {globalAddressErrors.address_2_error_status && (
                                          <span className="error-message-pincode-update">
                                            {globalAddressErrors.address_2}
                                          </span>
                                        )}
                                      </div>

                                      <div className="col-md-6">
                                        <label htmlFor="landmark">
                                          Landmark
                                        </label>
                                        <input
                                          type="text"
                                          id="landmark"
                                          name="landmark"
                                          placeholder="Landmark"
                                          maxLength={50}
                                          value={addressAdd.landmark}
                                          onChange={handleInputChange}
                                          className="form-control"
                                          // required
                                        />
                                        {globalAddressErrors.landmark_error_status && (
                                          <span className="error-message-pincode-update">
                                            {globalAddressErrors.landmark}
                                          </span>
                                        )}
                                      </div>

                                      <div className="col-md-6">
                                        <label htmlFor="pincode">
                                          Pincode
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>
                                        <input
                                          type="number"
                                          id="pincode"
                                          name="pincode"
                                          placeholder="Enter Pincode"
                                          value={addressAdd.pincode || ""}
                                          onChange={handlePincodeChange}
                                          className="form-control"
                                          required
                                          min="0"
                                          max="999999"
                                          onInvalid={(e) => {
                                            const target =
                                              e.target as HTMLInputElement; // Cast to HTMLInputElement
                                            target.setCustomValidity(
                                              "Please enter a valid 6-digit pincode."
                                            );
                                          }}
                                          onInput={(e) => {
                                            const target =
                                              e.target as HTMLInputElement; // Cast to HTMLInputElement
                                            target.setCustomValidity(""); // Reset error message
                                          }}
                                        />
                                        <span
                                          className="error-message-pincode-update"
                                          style={{
                                            display:
                                              addressAdd.pincode &&
                                              addressAdd.pincode.length < 6
                                                ? "block"
                                                : "none",
                                          }}
                                        >
                                          Pincode must be exactly 6 digits.
                                        </span>
                                        {pinServiceableMessage.length > 0 &&
                                          pinServiceableStatus && (
                                            <span className="error-message-pincode-update">
                                              {pinServiceableMessage}
                                            </span>
                                          )}
                                      </div>

                                      <div className="col-md-6">
                                        <label htmlFor="state">
                                          State
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>
                                        <input
                                          type="text"
                                          id="state"
                                          name="state"
                                          placeholder="State"
                                          value={addressAdd.state}
                                          onChange={handleInputChange}
                                          className="form-control"
                                          required
                                          disabled
                                        />
                                      </div>

                                      <div className="col-md-6">
                                        <label htmlFor="city">
                                          City
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>
                                        <input
                                          type="text"
                                          id="city"
                                          name="city"
                                          placeholder="City"
                                          value={addressAdd.city}
                                          onChange={handleInputChange}
                                          className="form-control"
                                          required
                                          disabled
                                        />
                                      </div>
                                      <div className="col-md-12">
                                      <button
                                        type="submit"
                                        disabled={!isFormValid()}
                                      >
                                        Submit Address
                                      </button>
                                      </div>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  {/* Address Table */}
                  <div className="address-table-profile">
                    {addresses.length > 0 ? (
                      addresses.map((address) => (
                        <div className="address-card">
                          <div className="address-card-box">
                            <h5>{userData.name}</h5>
                            <div className="card-box">
                              <p className="user-address">
                                {address.address_1} <br />
                                {address.address_2} <br />
                                {address.landmark} <br />
                                {address.city} ({address.pincode}) <br />
                                {address.state_id}
                              </p>
                              <p className="user-address">
                                Mobile: +91-{userData.mobile_no}
                              </p>
                            </div>
                          </div>

                          <div className="address-actions">
                            <button
                              className="btn btn-primary-custom"
                              onClick={() => {
                                setShowPopupAddress(address.address_id);
                                setNewAddress({
                                  address_1: address.address_1,
                                  address_2: address.address_2,
                                  landmark: address.landmark,
                                  city: address.city,
                                  state: address.state_id,
                                  pincode: address.pincode,
                                });
                              }}
                            >
                              Edit Address
                            </button>
                            {addressNumber !== 1 && ( // Conditionally render the Remove button
    <button
      className="btn btn-secondary-custom"
      data-bs-toggle="modal"
      data-bs-target="#exampleModal"
      // onClick={() =>
      //   handleDeleteAddress(address.address_id)
      // }
    >
      Remove
    </button>
  )}
                          </div>
                          <div
                            className="modal fade remove_add_popup"
                            id="exampleModal"
                            tabIndex={-1}
                            aria-labelledby="exampleModalLabel"
                            aria-hidden="true"
                          >
                            <div className="modal-dialog modal-dialog-centered modal-lg">
                              <div className="modal-content remove-">
                                <div
                                  className="modal-header"
                                  style={{ borderBottom: "none" }}
                                >
                                  {/* <h1 className="modal-title fs-5" id="exampleModalLabel">Remove Address</h1> */}
                                  <button
                                    type="button"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                  ></button>
                                </div>
                                <div className="modal-body modalbodyremoves text-center">
                                  Are you sure, you want to remove your address.
                                </div>
                                <div className="button-address-remove buttonaddressremoves">
                                  <button
                                    className="btn btn-secondary-custom remove-address"
                                    data-bs-toggle="modal"
                                    data-bs-target="#exampleModal"
                                    onClick={() =>
                                      handleDeleteAddress(address.address_id)
                                    }
                                  >
                                    Yes
                                  </button>
                                  <button
                                    className="btn btn-secondary-custom remove-address"
                                    data-bs-toggle="modal"
                                    data-bs-target="#exampleModal"
                                    aria-label="Close"
                                  >
                                    No
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          {showPopupAddress === address.address_id && (
                            <div className="popup update_address">
                              <div className="popup-content">
                                <div
                                  className="edit_address "
                                  id="exampleModal"
                                  tabIndex={-1}
                                  aria-labelledby="exampleModalLabel"
                                  aria-hidden="true"
                                  // id="exampleModal"
                                  // tabIndex={-1}
                                  // aria-labelledby="exampleModalLabel"
                                  // aria-hidden="true"
                                >
                                  <div className=" modal-dialog modal-dialog-centered modal-lg">
                                    <div className="modal-content">
                                      <div className="modal-header">
                                        <h1
                                          className="modal-title fs-5"
                                          id="exampleModalLabel"
                                        >
                                          Update Address
                                        </h1>
                                        <button
                                          className="close-button"
                                          onClick={() => {
                                            setShowPopupAddress(null);
                                            setNewAddress({
                                              address_1: "",
                                              address_2: "",
                                              landmark: "",
                                              city: "",
                                              state: "",
                                              pincode: "",
                                            });
                                          }}
                                        >
                                          <FontAwesomeIcon icon={faTimes} />
                                        </button>
                                      </div>
                                      <div className="modal-body">
                                        <form
                                          className="mt-4"
                                          onSubmit={(e) =>
                                            handleUpdateAddressSubmit(
                                              e,
                                              address.address_id
                                            )
                                          }
                                        >
                                          <div className="row g-3">
                                            <div className="col-md-6">
                                              <label htmlFor="address_1">
                                                Address 1
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </label>
                                              <input
                                                type="text"
                                                id="address_1"
                                                name="address_1"
                                                placeholder="Address 1"
                                                value={addressAdd.address_1}
                                                onChange={handleInputChange}
                                                className="form-control"
                                                maxLength={50}
                                                required
                                                onInvalid={(e) => {
                                                  const target =
                                                    e.target as HTMLInputElement;
                                                  if (!target.value) {
                                                    target.setCustomValidity(
                                                      "Address is required."
                                                    );
                                                  } else if (
                                                    target.value.length < 2
                                                  ) {
                                                    target.setCustomValidity(
                                                      "Address must be at least 2 characters long."
                                                    );
                                                  }
                                                }}
                                                onInput={(e) => {
                                                  const target =
                                                    e.target as HTMLInputElement;
                                                  target.setCustomValidity(""); // Clear error message
                                                }}
                                              />
                                              {globalAddressErrors.address_1_error_status && (
                                                <span className="error-message-pincode-update">
                                                  {
                                                    globalAddressErrors.address_1
                                                  }
                                                </span>
                                              )}
                                            </div>

                                            <div className="col-md-6">
                                              <label htmlFor="address_2">
                                                Address 2
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </label>
                                              <input
                                                type="text"
                                                id="address_2"
                                                name="address_2"
                                                placeholder="Address 2"
                                                value={addressAdd.address_2}
                                                onChange={handleInputChange}
                                                className="form-control"
                                                required
                                                maxLength={50}
                                                onInvalid={(e) => {
                                                  const target =
                                                    e.target as HTMLInputElement;
                                                  if (!target.value) {
                                                    target.setCustomValidity(
                                                      "Address is required."
                                                    );
                                                  } else if (
                                                    target.value.length < 2
                                                  ) {
                                                    target.setCustomValidity(
                                                      "Address must be at least 2 characters long."
                                                    );
                                                  }
                                                }}
                                                onInput={(e) => {
                                                  const target =
                                                    e.target as HTMLInputElement;
                                                  target.setCustomValidity(""); // Clear error message
                                                }}
                                              />
                                              {globalAddressErrors.address_2_error_status && (
                                                <span className="error-message-pincode-update">
                                                  {
                                                    globalAddressErrors.address_2
                                                  }
                                                </span>
                                              )}
                                            </div>

                                            <div className="col-md-6">
                                              <label htmlFor="landmark">
                                                Landmark
                                              </label>
                                              <input
                                                type="text"
                                                id="landmark"
                                                name="landmark"
                                                placeholder="Landmark"
                                                maxLength={50}
                                                value={addressAdd.landmark} // Prefill with existing data
                                                onChange={handleInputChange}
                                                className="form-control"
                                              />
                                              {globalAddressErrors.landmark_error_status && (
                                                <span className="error-message-pincode-update">
                                                  {globalAddressErrors.landmark}
                                                </span>
                                              )}
                                            </div>

                                            <div className="col-md-6">
                                              <label htmlFor="pincode">
                                                Pincode
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </label>
                                              <input
                                                type="number"
                                                id="pincode"
                                                name="pincode"
                                                placeholder="Enter Pincode"
                                                value={addressAdd.pincode || ""}
                                                onChange={handlePincodeChange}
                                                className="form-control"
                                                required
                                                min="0"
                                                max="999999"
                                                onInvalid={(e) => {
                                                  const target =
                                                    e.target as HTMLInputElement; // Cast to HTMLInputElement
                                                  target.setCustomValidity(
                                                    "Please enter a valid 6-digit pincode."
                                                  );
                                                }}
                                                onInput={(e) => {
                                                  const target =
                                                    e.target as HTMLInputElement; // Cast to HTMLInputElement
                                                  target.setCustomValidity(""); // Reset error message
                                                }}
                                              />
                                              <span
                                                className="error-message-pincode-update"
                                                style={{
                                                  display:
                                                    addressAdd.pincode &&
                                                    addressAdd.pincode.length <
                                                      6
                                                      ? "block"
                                                      : "none",
                                                }}
                                              >
                                                Pincode must be exactly 6
                                                digits.
                                              </span>
                                              {pinServiceableMessage.length >
                                                0 &&
                                                pinServiceableStatus && (
                                                  <span className="error-message-pincode-update">
                                                    {pinServiceableMessage}
                                                  </span>
                                                )}
                                            </div>

                                            <div className="col-md-6">
                                              <label htmlFor="state">
                                                State
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </label>
                                              <input
                                                type="text"
                                                id="state"
                                                name="state"
                                                placeholder="State"
                                                value={
                                                  addressAdd?.state
                                                    ? addressAdd?.state
                                                    : ""
                                                } // Prefill with existing data
                                                onChange={handleInputChange}
                                                className="form-control"
                                                required
                                                disabled
                                              />
                                            </div>

                                            <div className="col-md-6">
                                              <label htmlFor="city">
                                                City
                                                <span style={{ color: "red" }}>
                                                  *
                                                </span>
                                              </label>
                                              <input
                                                type="text"
                                                id="city"
                                                name="city"
                                                placeholder="City"
                                                value={addressAdd.city} // Prefill with existing data
                                                onChange={handleInputChange}
                                                className="form-control"
                                                required
                                                disabled
                                              />
                                            </div>
                                            <div className="col-md-12">
                                            <button
                                              type="submit"
                                              disabled={!isFormValid()}
                                            >
                                              Update Address
                                            </button>
                                            </div>
                                          </div>
                                        </form>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      ))
                    ) : (
                      <p className="no-address-message">
                        No addresses available
                      </p>
                    )}
                  </div>
                </div>
              ) : (
                <p>Loading user data...</p>
              )}
            </div>
          )}

          {activeSection === "Referrals" && (
            <div>
              <div className="row">
                <div className="main-row">
                  <div className="col-md-8">
                    <div className="referral p-4 ps-0">
                      <h2 className="referral-content">
                        Share your UID or Referral link to get additional ₹500
                        on your next item sold at Selsmart!
                      </h2>
                      <p className="referral-price ">
                        Referral earned - <span>₹1100</span>
                      </p>
                      <div className=" reff_btn_wrap d-flex align-items-center gap-3 mt-3">
                        <button className="referral-button">
                          SLMRT12345 <img src={copyIcon} />
                        </button>
                        <span className="or">or</span>
                        <button className="referral-button">
                          Referral link <img src={linkIcon} />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <img
                      src={referralIMage}
                      alt="Referral Image"
                      className="referral-image"
                    />
                  </div>
                </div>
              </div>
              <div className="row mt-4">
                <h2 className="terms-title">Referrals -</h2>
                <div className="col-md-6">
                  <div className="referral-card First">
                    <h3>Name: Rohit</h3>
                    <p className="referral-status">
                      Referral Status: 1 of 2 steps (Pending)
                    </p>
                    <div className="progress pend mb-3">
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: "50%" }}
                      ></div>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span className="lft_wrap">
                        <img
                          src={copleteIcon}
                          alt="Signup Icon"
                          className="left-icon"
                        />
                        Signup
                      </span>
                      <span className="rit_wrap peddinG">
                        <img
                          src={pendingIcon}
                          alt="Sold Item Icon"
                          className="left-icon"
                        />{" "}
                        Sold item on Selsmart
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="referral-card">
                    <h3>Name: Rohit</h3>
                    <p className="referral-status">
                      Referral Status: Completed
                    </p>
                    <div className="progress comp mb-3">
                      <div
                        className="progress-bar"
                        role="progressbar"
                        style={{ width: "100%" }}
                      ></div>
                    </div>
                    <div className="d-flex justify-content-between">
                      <span className="lft_wrap">
                        <img
                          src={copleteIcon}
                          alt="Signup Icon"
                          className="left-icon"
                        />{" "}
                        Signup
                      </span>
                      <span className="rit_wrap">
                        <img
                          src={copleteIcon}
                          alt="Sold Item Icon"
                          className="left-icon"
                        />{" "}
                        Sold item on Selsmart
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container mt-5">
                <h2 className="terms-title">Terms and Conditions -</h2>
                <ol className="tc">
                  <li>
                    <b>Eligibility:</b>
                    <p className="referral-term">
                      The referral program is open to all customers of Selsmart.
                    </p>
                  </li>
                  <li>
                    <b>Referral Code Usage:</b>
                    <p className="referral-term">
                      {" "}
                      Each referral code can be used only once by a new
                      customer.
                    </p>
                    <p className="referral-term">
                      The referral code must be entered at the time of the new
                      customer's first purchase on Selsmart.
                    </p>
                  </li>
                  <li>
                    <b>Rewards:</b>
                    <p className="referral-term">
                      {" "}
                      Both the referrer (sender) and the referred (receiver)
                      will receive an additional value on their respective
                      purchases.
                    </p>
                    <p className="referral-term">
                      The additional value is applicable on products sold at
                      Selsmart.
                    </p>
                  </li>
                  <li>
                    <b>Redemption:</b>
                    <p className="referral-term">
                      The additional value received by the referrer and the
                      referred will be applied as a discount on their next
                      purchase.
                    </p>
                    <p className="referral-term">
                      The discount cannot be combined with other offers or
                      promotions.
                    </p>
                  </li>
                  <li>
                    <b>Validity:</b>
                    <p className="referral-term">
                      The referral code is valid for 6 months from the date of
                      issue.
                    </p>
                    <p className="referral-term">
                      The discount received from the referral must be used
                      within 3 months of being credited.
                    </p>
                  </li>
                  <li>
                    <b>Limitations:</b>
                    <p className="referral-term">
                      A customer can refer up to 10 new customers.
                    </p>
                    <p className="referral-term">
                      The referral program cannot be used in conjunction with
                      any other referral or promotional programs.
                    </p>
                  </li>
                  <li>
                    <b>Abuse Prevention:</b>
                    <p className="referral-term">
                      Selsmart reserves the right to review and investigate all
                      referral activities and to suspend accounts or revoke
                      referral rewards if abuse or fraudulent activity is
                      detected.
                    </p>
                  </li>
                  <li>
                    <b>Modification and Termination:</b>
                    <p className="referral-term">
                      Selsmart reserves the right to modify or terminate the
                      referral program at any time without prior notice.
                    </p>
                    <p className="referral-term">
                      Any changes to the program will be communicated on the
                      Selsmart website.
                    </p>
                  </li>
                </ol>
              </div>
            </div>
          )}
        </div>
        {/* <!-- Modal --> */}
      </section>
      <div className={isLoading ? "page-blur" : ""}>
        {!isLoading ? (
          <div
            className="modal fade removeUser_popup"
            id="exampleModalRemoveUser"
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered custom-modal-size">
              <div className="modal-content">
                <div className="modal-header" style={{ borderBottom: "none" }}>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleCloseModal} // This should also work when you manually call handleCloseModal
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body text-center">
                  <div className="otp-form">
                    <div>
                      {/* <button  type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                // onClick={handleclose}
                                aria-label="Close"></button> */}
                  {error && <p className="error-verify-fail">{error}</p>}
                  <h3>Enter OTP</h3>
                  <p>
                    Please enter the six-digit OTP sent to <br /> (+91)-
                    {mobileNo &&
                    !isNaN(Number(mobileNo)) &&
                    mobileNo.length == 10
                      ? `${mobileNo.slice(0, 2)}xxxxxx${mobileNo.slice(-2)}`
                      : "95-xxxxxx-89"}
                  </p>
                </div>

                    <div className="otp-inputs">
                      {otp.map((_, index) => (
                        <input
                          key={index}
                          name={`otp-${index}`}
                          type="number"
                          maxLength={1}
                          placeholder="_"
                          value={otp[index]}
                          ref={(el) => (nameInputReff.current[index] = el)}
                          onChange={(e) => handleChangeOtp(e.target, index)}
                          onKeyDown={(e) => handleKeyDown(e, index)}
                        />
                      ))}
                    </div>
                    <div className="verify_Otp_btn_wrap remo">
                      <div className="social-buttons">
                        <button
                          className="btn btn-secondary- btn-outline-success re_send_otp"
                          onClick={handleResendOtp}
                          style={{
                            cursor: isDisabled ? "not-allowed" : "pointer",
                            // opacity: isDisabled ? 0.5 : 1,
                            display: isDisabled ? "none" : "block",
                          }}
                        >
                          Resend OTP
                        </button>
                        <button
                          className="btn btn-success verify_Otp"
                          onClick={() => handleOtpSubmit(otp)}
                        >
                          Verify OTP
                        </button>
                      </div>
                    </div>
                    <p className="trouble_otp">Trouble in getting OTP?</p>
                    <p className="chk_mobile_no">
                      Make sure you entered the correct mobile number.
                    </p>

                    <div className="otptext">
                      {/* <p className="info">An OTP has been sent to your Mobile No.</p> */}
                      <p className="request">
                        {isDisabled
                          ? `Request new OTP in ${convert_resend_button_timer()}`
                          : "You can request a new OTP"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) 
        : (
          <div
            className="modal fade removeUser_popup"
            id="exampleModalRemoveUser"
            tabIndex={-1}
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
            data-bs-dismiss={removeAccountVerifyOtpModal ? "modal":undefined}
            data-bs-backdrop="static" // Prevent closing when clicking outside
            data-bs-keyboard="false" // Optional: Prevent closing with the Escape key
          >
            <div className="modal-dialog modal-dialog-centered custom-modal-size">
              <div className="modal-content">
                <div className="modal-header" style={{ borderBottom: "none" }}>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={handleCloseModal} // This should also work when you manually call handleCloseModal
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  />
                </div>
                <div className="modal-body text-center">
                  <div className="otp-form">
                    <div>
                      {/* <button  type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                // onClick={handleclose}
                                aria-label="Close"></button> */}
                      {error && <p className="error-verify-fail">{error}</p>}
                      <h3>Enter OTP</h3>
                      <p>
                        Please enter the six-digit OTP sent to <br /> (+91)-
                        {mobileNo &&
                        !isNaN(Number(mobileNo)) &&
                        mobileNo.length === 10
                          ? `${mobileNo.slice(0, 2)}xxxxxx${mobileNo.slice(-2)}`
                          : "95-xxxxxx-89"}
                      </p>
                    </div>

                    <div className="otp-inputs">
                      {otp.map((_, index) => (
                        <input
                          key={index}
                          name={`otp-${index}`}
                          type="text"
                          maxLength={1}
                          placeholder="_"
                          value={otp[index]}
                          ref={(el) => (nameInputReff.current[index] = el)}
                          onChange={(e) => handleChangeOtp(e.target, index)}
                          onKeyDown={(e) => handleKeyDown(e, index)}
                        />
                      ))}
                    </div>
                    <div className="verify_Otp_btn_wrap remo">
                      <div className="social-buttons">
                        <button
                          className="btn btn-secondary- btn-outline-success re_send_otp"
                          onClick={handleResendOtp}
                          style={{
                            cursor: isDisabled ? "not-allowed" : "pointer",
                            // opacity: isDisabled ? 0.5 : 1,
                            display: isDisabled ? "none" : "block",
                          }}
                        >
                          Resend OTP
                        </button>
                        <button
                          className="btn btn-success verify_Otp"
                          onClick={() => handleOtpSubmit(otp)}
                        >
                          Verify OTP
                        </button>
                      </div>
                    </div>
                    <p className="trouble_otp">Trouble in getting OTP?</p>
                    <p className="chk_mobile_no">
                      Make sure you entered the correct mobile number.
                    </p>

                    <div className="otptext">
                      {/* <p className="info">An OTP has been sent to your Mobile No.</p> */}
                      <p className="request">
                        {isDisabled
                          ? `Request new OTP in ${convert_resend_button_timer()}`
                          : "You can request a new OTP"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
        }
      </div>

      {showModal && (
        <div className="modal-overlays remove_address_popup">
          <div className="modal-contents">
            {/* <img className="popup-trash-imagess" src={trashIcon} alt="Trash Icon" /> */}
            <p className="heading-popup-trashs">
            <strong>Do you want to delete your account?</strong> 
           <p className="second-line">Once deleted, all your data will be removed from our system.</p> 
            </p>
            <div className="modal-actionss">
              <button
                className="modal-remove-button"
                onClick={() => handleSendOtp()}
              >
                Yes, Delete my Account
              </button>
              <button
                className="modal-cancel-button btn btn-success"
                onClick={handleRemoveAccountCancel}
              >
                No, Keep my Account
              </button>
            </div>
          </div>
        </div>
      )}

{showDeleteInfoModal && (
        <div className="modal-overlays remove_address_popup">
          <div className="modal-contents">
            {/* <img className="popup-trash-imagess" src={trashIcon} alt="Trash Icon" /> */}
            <p className="heading-popup-trashs">
            <strong>Your account has been successfully deleted.</strong>
           <p className="second-line"> We are sorry to see you go, but you can create a new account anytime if you change your mind.</p>
            </p>
            <div className="modal-actionss">
              <button
                className="modal-remove-button okay-after-remove"
                onClick={() => handleOkayDelete()}
              >
                Okay
              </button>
            </div>
          </div>
        </div>
      )}

{showModalInfo && (
                    <div className="popup_cart" style={modalStyles.overlay}>
                      <div style={modalStyles.modal}>
                        {/* <FontAwesomeIcon className="cart-empty" icon={faShoppingCart} /> */}
                        <p className="cart-empty-msg">{popupMsg}</p>
                        <button
                          className="cart-empty-button"
                          onClick={handleCloseModalClick}
                        >
                          Okay
                        </button>
                      </div>
                    </div>
                  )}

      <Footer />
    </div>
  );
};

export default ProfilePage;
